/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from '../API'

type GeneratedSubscription<InputType, OutputType> = string & {
	__generatedSubscriptionInput: InputType
	__generatedSubscriptionOutput: OutputType
}

export const onUpdatePreparePurchaseByTenantId =
	/* GraphQL */ `subscription OnUpdatePreparePurchaseByTenantId($tenantId: ID!) {
  onUpdatePreparePurchaseByTenantId(tenantId: $tenantId) {
    id
    tenantId
    activeFlag
    uniqueTransactionId
    flag
    invoiceName
    ocrInvoiceName
    fileName
    ocrFileName
    invoiceDate
    ocrInvoiceDate
    paymentDate
    ocrPaymentDate
    paymentStatus
    preparePurchasePaidDate
    supplier
    ocrSupplier
    po
    ocrPO
    costlineName
    costlineName_fr
    projectName
    totalAmount
    taxAmount
    netAmountDetails {
      netAmount
      category
      projectId
      projectName
      projectNumber
      costlineId
      costlineName
      costlineName_fr
    }
    taxAmountDetails {
      taxAmount
      vatAccount
      vatIntracom
    }
    netAmount
    ocrTotalAmount
    ocrTaxAmount
    ocrNetAmount
    currency
    ocrCurrency
    type
    status
    currentPage
    prevPage
    archivedDate
    category
    ocrCategory
    note
    ocrNote
    invoiceDocuments {
      bucket
      region
      key
      identityId
    }
    poId
    quoteId
    supplierId
    costlineId
    projectId
    ocrStatus
    vatAccount
    ocrData {
      bucket
      region
      key
      identityId
    }
    invoiceKey
    paymentMethods
    vatIntracom
    bankAccountNumber
    paymentReference
    paymentReferenceType
    bankAccountName
    supplierAccountingNumber
    supplierAccountingName
    projectNumber
    quoteNumber
    lastExportedDate
    preparePurchaseToPayDate
    fullPurchaseNumber
    bridgePaymentLinkId
    billitInboxItemId
    billitPeppolFileId
    billitSenderPeppolId
    billitImportDate
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnUpdatePreparePurchaseByTenantIdSubscriptionVariables,
		APITypes.OnUpdatePreparePurchaseByTenantIdSubscription
	>
export const onCreateAuditEvent =
	/* GraphQL */ `subscription OnCreateAuditEvent(
  $filter: ModelSubscriptionAuditEventFilterInput
) {
  onCreateAuditEvent(filter: $filter) {
    tenantId
    sk
    id
    ts
    action
    outcome
    reason
    actor {
      type
      id
      email
    }
    source {
      type
      ip
      userAgent
      sessionId
    }
    entity {
      type
      id
      externalId
      provider
    }
    entityKey
    before
    after
    metadata
    correlationId
    requestId
    idempotencyKey
    env
    hash
    prevHash
    ttl
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnCreateAuditEventSubscriptionVariables,
		APITypes.OnCreateAuditEventSubscription
	>
export const onUpdateAuditEvent =
	/* GraphQL */ `subscription OnUpdateAuditEvent(
  $filter: ModelSubscriptionAuditEventFilterInput
) {
  onUpdateAuditEvent(filter: $filter) {
    tenantId
    sk
    id
    ts
    action
    outcome
    reason
    actor {
      type
      id
      email
    }
    source {
      type
      ip
      userAgent
      sessionId
    }
    entity {
      type
      id
      externalId
      provider
    }
    entityKey
    before
    after
    metadata
    correlationId
    requestId
    idempotencyKey
    env
    hash
    prevHash
    ttl
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnUpdateAuditEventSubscriptionVariables,
		APITypes.OnUpdateAuditEventSubscription
	>
export const onDeleteAuditEvent =
	/* GraphQL */ `subscription OnDeleteAuditEvent(
  $filter: ModelSubscriptionAuditEventFilterInput
) {
  onDeleteAuditEvent(filter: $filter) {
    tenantId
    sk
    id
    ts
    action
    outcome
    reason
    actor {
      type
      id
      email
    }
    source {
      type
      ip
      userAgent
      sessionId
    }
    entity {
      type
      id
      externalId
      provider
    }
    entityKey
    before
    after
    metadata
    correlationId
    requestId
    idempotencyKey
    env
    hash
    prevHash
    ttl
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnDeleteAuditEventSubscriptionVariables,
		APITypes.OnDeleteAuditEventSubscription
	>
export const onCreateBankAccountInfo =
	/* GraphQL */ `subscription OnCreateBankAccountInfo(
  $filter: ModelSubscriptionBankAccountInfoFilterInput
) {
  onCreateBankAccountInfo(filter: $filter) {
    id
    tenantId
    activeFlag
    isSelected
    name
    balance
    status
    status_code_info
    status_code_description
    updated_at
    type
    currency_code
    item_id
    bank_id
    loan_details {
      next_payment_date
      next_payment_amount
      maturity_date
      opening_date
      interest_rate
      type
      borrowed_capital
      repaid_capital
      remaining_capital
    }
    savings_details {
      opening_date
      interest_rate
      ceiling
    }
    is_pro
    iban
    balanceHistory {
      balance
      updated_at
    }
    lastUpdatedTransactionDate
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedSubscription<
		APITypes.OnCreateBankAccountInfoSubscriptionVariables,
		APITypes.OnCreateBankAccountInfoSubscription
	>
export const onUpdateBankAccountInfo =
	/* GraphQL */ `subscription OnUpdateBankAccountInfo(
  $filter: ModelSubscriptionBankAccountInfoFilterInput
) {
  onUpdateBankAccountInfo(filter: $filter) {
    id
    tenantId
    activeFlag
    isSelected
    name
    balance
    status
    status_code_info
    status_code_description
    updated_at
    type
    currency_code
    item_id
    bank_id
    loan_details {
      next_payment_date
      next_payment_amount
      maturity_date
      opening_date
      interest_rate
      type
      borrowed_capital
      repaid_capital
      remaining_capital
    }
    savings_details {
      opening_date
      interest_rate
      ceiling
    }
    is_pro
    iban
    balanceHistory {
      balance
      updated_at
    }
    lastUpdatedTransactionDate
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedSubscription<
		APITypes.OnUpdateBankAccountInfoSubscriptionVariables,
		APITypes.OnUpdateBankAccountInfoSubscription
	>
export const onDeleteBankAccountInfo =
	/* GraphQL */ `subscription OnDeleteBankAccountInfo(
  $filter: ModelSubscriptionBankAccountInfoFilterInput
) {
  onDeleteBankAccountInfo(filter: $filter) {
    id
    tenantId
    activeFlag
    isSelected
    name
    balance
    status
    status_code_info
    status_code_description
    updated_at
    type
    currency_code
    item_id
    bank_id
    loan_details {
      next_payment_date
      next_payment_amount
      maturity_date
      opening_date
      interest_rate
      type
      borrowed_capital
      repaid_capital
      remaining_capital
    }
    savings_details {
      opening_date
      interest_rate
      ceiling
    }
    is_pro
    iban
    balanceHistory {
      balance
      updated_at
    }
    lastUpdatedTransactionDate
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedSubscription<
		APITypes.OnDeleteBankAccountInfoSubscriptionVariables,
		APITypes.OnDeleteBankAccountInfoSubscription
	>
export const onCreateBankTransactions =
	/* GraphQL */ `subscription OnCreateBankTransactions(
  $filter: ModelSubscriptionBankTransactionsFilterInput
) {
  onCreateBankTransactions(filter: $filter) {
    id
    tenantId
    activeFlag
    flag
    clean_description
    bank_description
    amount
    date
    updated_at
    currency_code
    is_deleted
    category_id
    account_id
    account_name
    is_future
    show_client_side
    projectId
    projectName
    status
    tags
    transactionType
    uniqueTransactionId
    invoices {
      items {
        id
        tenantId
        proposalId
        quoteType
        activeFlag
        originalInvoiceId
        creditInvoiceGenerated
        archivedDate
        paidDate
        paymentStatus
        quoteName
        quoteNumber
        projectName
        projectNumber
        clientId
        contactId
        clientName
        contactName
        clientTaxType
        clientEmail
        clientAddress
        clientCountry
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        title
        invoiceNumber
        poNumber
        invoiceAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        clientNote
        isDetailed
        isClientTaxRate
        bankProfileNumber
        invoicesBankProfileName
        invoicesBank
        invoicesIban
        invoicesBic
        invoicesAccountName
        invoiceDate
        invoiceDueDate
        description
        creditComments
        invoiceType
        proposalsDraft {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
          salesAccNumberType
        }
        taxDetails {
          taxRate
          taxPercentage
          taxAmount
          taxableAmount
        }
        salesAccNumberType
        sectionDetails {
          type
          amount
        }
        sectionDetailsByQuote {
          type
          amount
        }
        sectionDetailsByAccSection {
          type
          amount
        }
        proposals {
          id
          tenantId
          activeFlag
          quoteId
          quoteType
          clientId
          contactId
          status
          noofInvoices
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          createdOn
          updatedOn
          poDate
          poName
          poAmount
          poCurrency
          poNotes
          poVersion
          prevStatus
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          _deleted
          _version
          _lastChangedAt
        }
        createdOn
        updatedOn
        uniqueTransactionId
        assignedTenantId
        assignedTenantName
        showBidLetter
        companyLogo
        lastExportedDate
        emailSent
        draftEmailData {
          toEmail
          toCC
          toBCC
          subject
          body
          template
        }
        emailHistory {
          date
          subject
        }
        billitInboxItemId
        billitPeppolStatus
        billitPeppolError
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    preparePurchase {
      items {
        id
        tenantId
        activeFlag
        uniqueTransactionId
        flag
        invoiceName
        ocrInvoiceName
        fileName
        ocrFileName
        invoiceDate
        ocrInvoiceDate
        paymentDate
        ocrPaymentDate
        paymentStatus
        preparePurchasePaidDate
        supplier
        ocrSupplier
        po
        ocrPO
        costlineName
        costlineName_fr
        projectName
        totalAmount
        taxAmount
        netAmountDetails {
          netAmount
          category
          projectId
          projectName
          projectNumber
          costlineId
          costlineName
          costlineName_fr
        }
        taxAmountDetails {
          taxAmount
          vatAccount
          vatIntracom
        }
        netAmount
        ocrTotalAmount
        ocrTaxAmount
        ocrNetAmount
        currency
        ocrCurrency
        type
        status
        currentPage
        prevPage
        archivedDate
        category
        ocrCategory
        note
        ocrNote
        invoiceDocuments {
          bucket
          region
          key
          identityId
        }
        poId
        quoteId
        supplierId
        costlineId
        projectId
        ocrStatus
        vatAccount
        ocrData {
          bucket
          region
          key
          identityId
        }
        invoiceKey
        paymentMethods
        vatIntracom
        bankAccountNumber
        paymentReference
        paymentReferenceType
        bankAccountName
        supplierAccountingNumber
        supplierAccountingName
        projectNumber
        quoteNumber
        lastExportedDate
        preparePurchaseToPayDate
        fullPurchaseNumber
        bridgePaymentLinkId
        billitInboxItemId
        billitPeppolFileId
        billitSenderPeppolId
        billitImportDate
        createdOn
        updatedOn
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    miscAccNo
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedSubscription<
		APITypes.OnCreateBankTransactionsSubscriptionVariables,
		APITypes.OnCreateBankTransactionsSubscription
	>
export const onUpdateBankTransactions =
	/* GraphQL */ `subscription OnUpdateBankTransactions(
  $filter: ModelSubscriptionBankTransactionsFilterInput
) {
  onUpdateBankTransactions(filter: $filter) {
    id
    tenantId
    activeFlag
    flag
    clean_description
    bank_description
    amount
    date
    updated_at
    currency_code
    is_deleted
    category_id
    account_id
    account_name
    is_future
    show_client_side
    projectId
    projectName
    status
    tags
    transactionType
    uniqueTransactionId
    invoices {
      items {
        id
        tenantId
        proposalId
        quoteType
        activeFlag
        originalInvoiceId
        creditInvoiceGenerated
        archivedDate
        paidDate
        paymentStatus
        quoteName
        quoteNumber
        projectName
        projectNumber
        clientId
        contactId
        clientName
        contactName
        clientTaxType
        clientEmail
        clientAddress
        clientCountry
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        title
        invoiceNumber
        poNumber
        invoiceAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        clientNote
        isDetailed
        isClientTaxRate
        bankProfileNumber
        invoicesBankProfileName
        invoicesBank
        invoicesIban
        invoicesBic
        invoicesAccountName
        invoiceDate
        invoiceDueDate
        description
        creditComments
        invoiceType
        proposalsDraft {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
          salesAccNumberType
        }
        taxDetails {
          taxRate
          taxPercentage
          taxAmount
          taxableAmount
        }
        salesAccNumberType
        sectionDetails {
          type
          amount
        }
        sectionDetailsByQuote {
          type
          amount
        }
        sectionDetailsByAccSection {
          type
          amount
        }
        proposals {
          id
          tenantId
          activeFlag
          quoteId
          quoteType
          clientId
          contactId
          status
          noofInvoices
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          createdOn
          updatedOn
          poDate
          poName
          poAmount
          poCurrency
          poNotes
          poVersion
          prevStatus
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          _deleted
          _version
          _lastChangedAt
        }
        createdOn
        updatedOn
        uniqueTransactionId
        assignedTenantId
        assignedTenantName
        showBidLetter
        companyLogo
        lastExportedDate
        emailSent
        draftEmailData {
          toEmail
          toCC
          toBCC
          subject
          body
          template
        }
        emailHistory {
          date
          subject
        }
        billitInboxItemId
        billitPeppolStatus
        billitPeppolError
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    preparePurchase {
      items {
        id
        tenantId
        activeFlag
        uniqueTransactionId
        flag
        invoiceName
        ocrInvoiceName
        fileName
        ocrFileName
        invoiceDate
        ocrInvoiceDate
        paymentDate
        ocrPaymentDate
        paymentStatus
        preparePurchasePaidDate
        supplier
        ocrSupplier
        po
        ocrPO
        costlineName
        costlineName_fr
        projectName
        totalAmount
        taxAmount
        netAmountDetails {
          netAmount
          category
          projectId
          projectName
          projectNumber
          costlineId
          costlineName
          costlineName_fr
        }
        taxAmountDetails {
          taxAmount
          vatAccount
          vatIntracom
        }
        netAmount
        ocrTotalAmount
        ocrTaxAmount
        ocrNetAmount
        currency
        ocrCurrency
        type
        status
        currentPage
        prevPage
        archivedDate
        category
        ocrCategory
        note
        ocrNote
        invoiceDocuments {
          bucket
          region
          key
          identityId
        }
        poId
        quoteId
        supplierId
        costlineId
        projectId
        ocrStatus
        vatAccount
        ocrData {
          bucket
          region
          key
          identityId
        }
        invoiceKey
        paymentMethods
        vatIntracom
        bankAccountNumber
        paymentReference
        paymentReferenceType
        bankAccountName
        supplierAccountingNumber
        supplierAccountingName
        projectNumber
        quoteNumber
        lastExportedDate
        preparePurchaseToPayDate
        fullPurchaseNumber
        bridgePaymentLinkId
        billitInboxItemId
        billitPeppolFileId
        billitSenderPeppolId
        billitImportDate
        createdOn
        updatedOn
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    miscAccNo
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedSubscription<
		APITypes.OnUpdateBankTransactionsSubscriptionVariables,
		APITypes.OnUpdateBankTransactionsSubscription
	>
export const onDeleteBankTransactions =
	/* GraphQL */ `subscription OnDeleteBankTransactions(
  $filter: ModelSubscriptionBankTransactionsFilterInput
) {
  onDeleteBankTransactions(filter: $filter) {
    id
    tenantId
    activeFlag
    flag
    clean_description
    bank_description
    amount
    date
    updated_at
    currency_code
    is_deleted
    category_id
    account_id
    account_name
    is_future
    show_client_side
    projectId
    projectName
    status
    tags
    transactionType
    uniqueTransactionId
    invoices {
      items {
        id
        tenantId
        proposalId
        quoteType
        activeFlag
        originalInvoiceId
        creditInvoiceGenerated
        archivedDate
        paidDate
        paymentStatus
        quoteName
        quoteNumber
        projectName
        projectNumber
        clientId
        contactId
        clientName
        contactName
        clientTaxType
        clientEmail
        clientAddress
        clientCountry
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        title
        invoiceNumber
        poNumber
        invoiceAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        clientNote
        isDetailed
        isClientTaxRate
        bankProfileNumber
        invoicesBankProfileName
        invoicesBank
        invoicesIban
        invoicesBic
        invoicesAccountName
        invoiceDate
        invoiceDueDate
        description
        creditComments
        invoiceType
        proposalsDraft {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
          salesAccNumberType
        }
        taxDetails {
          taxRate
          taxPercentage
          taxAmount
          taxableAmount
        }
        salesAccNumberType
        sectionDetails {
          type
          amount
        }
        sectionDetailsByQuote {
          type
          amount
        }
        sectionDetailsByAccSection {
          type
          amount
        }
        proposals {
          id
          tenantId
          activeFlag
          quoteId
          quoteType
          clientId
          contactId
          status
          noofInvoices
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          createdOn
          updatedOn
          poDate
          poName
          poAmount
          poCurrency
          poNotes
          poVersion
          prevStatus
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          _deleted
          _version
          _lastChangedAt
        }
        createdOn
        updatedOn
        uniqueTransactionId
        assignedTenantId
        assignedTenantName
        showBidLetter
        companyLogo
        lastExportedDate
        emailSent
        draftEmailData {
          toEmail
          toCC
          toBCC
          subject
          body
          template
        }
        emailHistory {
          date
          subject
        }
        billitInboxItemId
        billitPeppolStatus
        billitPeppolError
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    preparePurchase {
      items {
        id
        tenantId
        activeFlag
        uniqueTransactionId
        flag
        invoiceName
        ocrInvoiceName
        fileName
        ocrFileName
        invoiceDate
        ocrInvoiceDate
        paymentDate
        ocrPaymentDate
        paymentStatus
        preparePurchasePaidDate
        supplier
        ocrSupplier
        po
        ocrPO
        costlineName
        costlineName_fr
        projectName
        totalAmount
        taxAmount
        netAmountDetails {
          netAmount
          category
          projectId
          projectName
          projectNumber
          costlineId
          costlineName
          costlineName_fr
        }
        taxAmountDetails {
          taxAmount
          vatAccount
          vatIntracom
        }
        netAmount
        ocrTotalAmount
        ocrTaxAmount
        ocrNetAmount
        currency
        ocrCurrency
        type
        status
        currentPage
        prevPage
        archivedDate
        category
        ocrCategory
        note
        ocrNote
        invoiceDocuments {
          bucket
          region
          key
          identityId
        }
        poId
        quoteId
        supplierId
        costlineId
        projectId
        ocrStatus
        vatAccount
        ocrData {
          bucket
          region
          key
          identityId
        }
        invoiceKey
        paymentMethods
        vatIntracom
        bankAccountNumber
        paymentReference
        paymentReferenceType
        bankAccountName
        supplierAccountingNumber
        supplierAccountingName
        projectNumber
        quoteNumber
        lastExportedDate
        preparePurchaseToPayDate
        fullPurchaseNumber
        bridgePaymentLinkId
        billitInboxItemId
        billitPeppolFileId
        billitSenderPeppolId
        billitImportDate
        createdOn
        updatedOn
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    miscAccNo
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedSubscription<
		APITypes.OnDeleteBankTransactionsSubscriptionVariables,
		APITypes.OnDeleteBankTransactionsSubscription
	>
export const onCreateBillitInboxTracker =
	/* GraphQL */ `subscription OnCreateBillitInboxTracker(
  $filter: ModelSubscriptionBillitInboxTrackerFilterInput
) {
  onCreateBillitInboxTracker(filter: $filter) {
    id
    tenantId
    billitInboxItemId
    billitPeppolFileId
    preparePurchaseId
    senderPeppolId
    documentType
    status
    errorMessage
    rawUblData
    responseType
    responseCode
    referencedDocumentId
    senderName
    receiverName
    statusReasonCode
    statusReason
    effectiveDate
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnCreateBillitInboxTrackerSubscriptionVariables,
		APITypes.OnCreateBillitInboxTrackerSubscription
	>
export const onUpdateBillitInboxTracker =
	/* GraphQL */ `subscription OnUpdateBillitInboxTracker(
  $filter: ModelSubscriptionBillitInboxTrackerFilterInput
) {
  onUpdateBillitInboxTracker(filter: $filter) {
    id
    tenantId
    billitInboxItemId
    billitPeppolFileId
    preparePurchaseId
    senderPeppolId
    documentType
    status
    errorMessage
    rawUblData
    responseType
    responseCode
    referencedDocumentId
    senderName
    receiverName
    statusReasonCode
    statusReason
    effectiveDate
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnUpdateBillitInboxTrackerSubscriptionVariables,
		APITypes.OnUpdateBillitInboxTrackerSubscription
	>
export const onDeleteBillitInboxTracker =
	/* GraphQL */ `subscription OnDeleteBillitInboxTracker(
  $filter: ModelSubscriptionBillitInboxTrackerFilterInput
) {
  onDeleteBillitInboxTracker(filter: $filter) {
    id
    tenantId
    billitInboxItemId
    billitPeppolFileId
    preparePurchaseId
    senderPeppolId
    documentType
    status
    errorMessage
    rawUblData
    responseType
    responseCode
    referencedDocumentId
    senderName
    receiverName
    statusReasonCode
    statusReason
    effectiveDate
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnDeleteBillitInboxTrackerSubscriptionVariables,
		APITypes.OnDeleteBillitInboxTrackerSubscription
	>
export const onCreateClients =
	/* GraphQL */ `subscription OnCreateClients($filter: ModelSubscriptionClientsFilterInput) {
  onCreateClients(filter: $filter) {
    id
    name
    email
    tenantId
    parentTeamId
    offlineIds
    activeFlag
    teamCount
    projects {
      items {
        id
        name
        tenantId
        freelancers
        childFreelancers
        offlineIds
        parentProjectId
        parentClientId
        activeFlag
        type
        parentTeamId
        parentSubTeamId
        isSubTeam
        projectType
        projectGroup
        parentCompanyId
        projectNumber
        subTeamCount
        createdOn
        updatedOn
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnCreateClientsSubscriptionVariables,
		APITypes.OnCreateClientsSubscription
	>
export const onUpdateClients =
	/* GraphQL */ `subscription OnUpdateClients($filter: ModelSubscriptionClientsFilterInput) {
  onUpdateClients(filter: $filter) {
    id
    name
    email
    tenantId
    parentTeamId
    offlineIds
    activeFlag
    teamCount
    projects {
      items {
        id
        name
        tenantId
        freelancers
        childFreelancers
        offlineIds
        parentProjectId
        parentClientId
        activeFlag
        type
        parentTeamId
        parentSubTeamId
        isSubTeam
        projectType
        projectGroup
        parentCompanyId
        projectNumber
        subTeamCount
        createdOn
        updatedOn
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnUpdateClientsSubscriptionVariables,
		APITypes.OnUpdateClientsSubscription
	>
export const onDeleteClients =
	/* GraphQL */ `subscription OnDeleteClients($filter: ModelSubscriptionClientsFilterInput) {
  onDeleteClients(filter: $filter) {
    id
    name
    email
    tenantId
    parentTeamId
    offlineIds
    activeFlag
    teamCount
    projects {
      items {
        id
        name
        tenantId
        freelancers
        childFreelancers
        offlineIds
        parentProjectId
        parentClientId
        activeFlag
        type
        parentTeamId
        parentSubTeamId
        isSubTeam
        projectType
        projectGroup
        parentCompanyId
        projectNumber
        subTeamCount
        createdOn
        updatedOn
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnDeleteClientsSubscriptionVariables,
		APITypes.OnDeleteClientsSubscription
	>
export const onCreateComments =
	/* GraphQL */ `subscription OnCreateComments($filter: ModelSubscriptionCommentsFilterInput) {
  onCreateComments(filter: $filter) {
    id
    quoteId
    activeFlag
    text
    parentId
    sectionId
    ownerEmail
    ownerSub
    status
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnCreateCommentsSubscriptionVariables,
		APITypes.OnCreateCommentsSubscription
	>
export const onUpdateComments =
	/* GraphQL */ `subscription OnUpdateComments($filter: ModelSubscriptionCommentsFilterInput) {
  onUpdateComments(filter: $filter) {
    id
    quoteId
    activeFlag
    text
    parentId
    sectionId
    ownerEmail
    ownerSub
    status
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnUpdateCommentsSubscriptionVariables,
		APITypes.OnUpdateCommentsSubscription
	>
export const onDeleteComments =
	/* GraphQL */ `subscription OnDeleteComments($filter: ModelSubscriptionCommentsFilterInput) {
  onDeleteComments(filter: $filter) {
    id
    quoteId
    activeFlag
    text
    parentId
    sectionId
    ownerEmail
    ownerSub
    status
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnDeleteCommentsSubscriptionVariables,
		APITypes.OnDeleteCommentsSubscription
	>
export const onCreateCompany =
	/* GraphQL */ `subscription OnCreateCompany($filter: ModelSubscriptionCompanyFilterInput) {
  onCreateCompany(filter: $filter) {
    id
    tenantId
    name
    email
    phone
    website
    registrationNumber
    vatNumber
    addressLine1
    addressLine2
    pdfPrimaryColor
    pdfSecondaryColor
    logoImage {
      bucket
      region
      key
      identityId
    }
    logoImage2 {
      bucket
      region
      key
      identityId
    }
    logoImage3 {
      bucket
      region
      key
      identityId
    }
    logoImage4 {
      bucket
      region
      key
      identityId
    }
    logoImageText
    logoImage2Text
    logoImage3Text
    logoImage4Text
    invoiceCount
    purchaseOrderInvoiceCount
    invoicingYear
    bank
    iban
    bic
    accountName
    bankProfileName
    bankProfileName2
    bank2
    iban2
    bic2
    accountName2
    bankProfileName3
    bank3
    iban3
    bic3
    accountName3
    bankProfileName4
    bank4
    iban4
    bic4
    accountName4
    bankProfileName5
    bank5
    iban5
    bic5
    accountName5
    accountCurrency
    country
    duplicateQuoteCounter
    exportInfo {
      exportDate
      user
    }
    companyEmailId
    createPurchaseRecap
    termsAndCondition1
    termsAndCondition2
    poTANDC1 {
      bucket
      region
      key
      identityId
    }
    soundProdTAndC1 {
      bucket
      region
      key
      identityId
    }
    soundProdTAndC2 {
      bucket
      region
      key
      identityId
    }
    editorialTAndC {
      bucket
      region
      key
      identityId
    }
    commercialTAndC {
      bucket
      region
      key
      identityId
    }
    setDesignTAndC {
      bucket
      region
      key
      identityId
    }
    wardrobeTAndC {
      bucket
      region
      key
      identityId
    }
    editorialEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    commercialEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    setDesignEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    wardrobeEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    digitalTAndC {
      bucket
      region
      key
      identityId
    }
    animationTAndC {
      bucket
      region
      key
      identityId
    }
    animationEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    frenchApfpTAndC1 {
      bucket
      region
      key
      identityId
    }
    frenchApfpTAndC2 {
      bucket
      region
      key
      identityId
    }
    blankQuoteTAndC {
      bucket
      region
      key
      identityId
    }
    blankQuoteEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    aicpTAndC {
      bucket
      region
      key
      identityId
    }
    purchaseTags {
      title
      color
    }
    favouriteProjects {
      id
      name
      selectedDate
    }
    teamCount
    subTeamCount
    projectCount {
      type
      count
      year
      name
    }
    projectGroupCount {
      type
      count
      year
      name
    }
    quoteCount {
      type
      count
      year
      name
    }
    quoteTemplateDetails {
      type
      quoteId
      parentTeamId
      parentSubTeamId
      quoteName
    }
    quoteAccountingCategoryAllow
    quoteAccountingCategory {
      name
    }
    quoteTertiaryCategoryAllow
    quoteTertiaryCategory {
      name
    }
    taxRateType
    salesAccNumberType
    salesAccByCostlineDetails {
      id
      EUName
      EUNumber
      InternationalName
      InternationalNumber
      LocalName
      LocalNumber
    }
    salesAccQuoteTypeDetails {
      type
      EUName
      EUNumber
      InternationalName
      InternationalNumber
      LocalName
      LocalNumber
    }
    aicpEUName
    aicpEUNumber
    aicpInternationalName
    aicpInternationalNumber
    aicpLocalName
    aicpLocalNumber
    apfpEUName
    apfpEUNumber
    apfpInternationalName
    apfpInternationalNumber
    apfpLocalName
    apfpLocalNumber
    photoEUName
    photoEUNumber
    photoInternationalName
    photoInternationalNumber
    photoLocalName
    photoLocalNumber
    postProdEUName
    postProdEUNumber
    postProdInternationalName
    postProdInternationalNumber
    postProdLocalName
    postProdLocalNumber
    vat20
    vat10
    specialEnglishInvoiceNote
    specialFrenchInvoiceNote
    costCategoriesFields {
      id
      name
    }
    costVatFields {
      number
      name
      text
    }
    miscAccNosFields {
      name
      number
      text
    }
    clientsSubAcc
    suppliersSubAcc
    userBridgeApiLoginDetails {
      uuid
      email
    }
    userBankingAutehticationDetails {
      access_token
      expires_at
      user {
        uuid
        email
      }
    }
    isLoggedIntoBanking
    lastUpdatedTransactionDate
    vatIntracom {
      type
      debitNumber
      debitName
      creditNumber
      creditName
    }
    sendCostlinesToReviewPage
    sendOverheadsToReviewPage
    activateDeliveryDate
    defaultProjectType
    paymentTerms
    localOtNumberOfHours
    exeOtNumberOfHours
    projectNumberCustomisation {
      seperator
      first
      second
      third
    }
    useOneProjectNumber
    commonProjectNumber
    individualSuppliersSubAcc
    clientsSalesAccountNumber
    suppliersCostAccountNumber
    quoteNumberCustomisation {
      seperator
      first
      second
      third
    }
    useOneQuoteNumber
    commonQuoteNumber
    commonProjectGroupFlag
    commonProjectGroup
    restrictProjectGroup
    salesLedgerName
    purchasesLedgerName
    ledgerNames {
      bankProfileName
      bridgeBankAccountId
      number
      name
      label
    }
    quoteJsonDetails {
      name
      quoteType
      categories {
        Bucket
        Key
        identityId
      }
      subcategories {
        Bucket
        Key
        identityId
      }
      costline {
        Bucket
        Key
        identityId
      }
    }
    purchaseCount
    invoiceNumberPrefix
    poNumberPrefix
    emailTemplateArray {
      id
      language
      name
      subject
      body
    }
    billitPartyId
    billitApiKey
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnCreateCompanySubscriptionVariables,
		APITypes.OnCreateCompanySubscription
	>
export const onUpdateCompany =
	/* GraphQL */ `subscription OnUpdateCompany($filter: ModelSubscriptionCompanyFilterInput) {
  onUpdateCompany(filter: $filter) {
    id
    tenantId
    name
    email
    phone
    website
    registrationNumber
    vatNumber
    addressLine1
    addressLine2
    pdfPrimaryColor
    pdfSecondaryColor
    logoImage {
      bucket
      region
      key
      identityId
    }
    logoImage2 {
      bucket
      region
      key
      identityId
    }
    logoImage3 {
      bucket
      region
      key
      identityId
    }
    logoImage4 {
      bucket
      region
      key
      identityId
    }
    logoImageText
    logoImage2Text
    logoImage3Text
    logoImage4Text
    invoiceCount
    purchaseOrderInvoiceCount
    invoicingYear
    bank
    iban
    bic
    accountName
    bankProfileName
    bankProfileName2
    bank2
    iban2
    bic2
    accountName2
    bankProfileName3
    bank3
    iban3
    bic3
    accountName3
    bankProfileName4
    bank4
    iban4
    bic4
    accountName4
    bankProfileName5
    bank5
    iban5
    bic5
    accountName5
    accountCurrency
    country
    duplicateQuoteCounter
    exportInfo {
      exportDate
      user
    }
    companyEmailId
    createPurchaseRecap
    termsAndCondition1
    termsAndCondition2
    poTANDC1 {
      bucket
      region
      key
      identityId
    }
    soundProdTAndC1 {
      bucket
      region
      key
      identityId
    }
    soundProdTAndC2 {
      bucket
      region
      key
      identityId
    }
    editorialTAndC {
      bucket
      region
      key
      identityId
    }
    commercialTAndC {
      bucket
      region
      key
      identityId
    }
    setDesignTAndC {
      bucket
      region
      key
      identityId
    }
    wardrobeTAndC {
      bucket
      region
      key
      identityId
    }
    editorialEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    commercialEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    setDesignEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    wardrobeEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    digitalTAndC {
      bucket
      region
      key
      identityId
    }
    animationTAndC {
      bucket
      region
      key
      identityId
    }
    animationEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    frenchApfpTAndC1 {
      bucket
      region
      key
      identityId
    }
    frenchApfpTAndC2 {
      bucket
      region
      key
      identityId
    }
    blankQuoteTAndC {
      bucket
      region
      key
      identityId
    }
    blankQuoteEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    aicpTAndC {
      bucket
      region
      key
      identityId
    }
    purchaseTags {
      title
      color
    }
    favouriteProjects {
      id
      name
      selectedDate
    }
    teamCount
    subTeamCount
    projectCount {
      type
      count
      year
      name
    }
    projectGroupCount {
      type
      count
      year
      name
    }
    quoteCount {
      type
      count
      year
      name
    }
    quoteTemplateDetails {
      type
      quoteId
      parentTeamId
      parentSubTeamId
      quoteName
    }
    quoteAccountingCategoryAllow
    quoteAccountingCategory {
      name
    }
    quoteTertiaryCategoryAllow
    quoteTertiaryCategory {
      name
    }
    taxRateType
    salesAccNumberType
    salesAccByCostlineDetails {
      id
      EUName
      EUNumber
      InternationalName
      InternationalNumber
      LocalName
      LocalNumber
    }
    salesAccQuoteTypeDetails {
      type
      EUName
      EUNumber
      InternationalName
      InternationalNumber
      LocalName
      LocalNumber
    }
    aicpEUName
    aicpEUNumber
    aicpInternationalName
    aicpInternationalNumber
    aicpLocalName
    aicpLocalNumber
    apfpEUName
    apfpEUNumber
    apfpInternationalName
    apfpInternationalNumber
    apfpLocalName
    apfpLocalNumber
    photoEUName
    photoEUNumber
    photoInternationalName
    photoInternationalNumber
    photoLocalName
    photoLocalNumber
    postProdEUName
    postProdEUNumber
    postProdInternationalName
    postProdInternationalNumber
    postProdLocalName
    postProdLocalNumber
    vat20
    vat10
    specialEnglishInvoiceNote
    specialFrenchInvoiceNote
    costCategoriesFields {
      id
      name
    }
    costVatFields {
      number
      name
      text
    }
    miscAccNosFields {
      name
      number
      text
    }
    clientsSubAcc
    suppliersSubAcc
    userBridgeApiLoginDetails {
      uuid
      email
    }
    userBankingAutehticationDetails {
      access_token
      expires_at
      user {
        uuid
        email
      }
    }
    isLoggedIntoBanking
    lastUpdatedTransactionDate
    vatIntracom {
      type
      debitNumber
      debitName
      creditNumber
      creditName
    }
    sendCostlinesToReviewPage
    sendOverheadsToReviewPage
    activateDeliveryDate
    defaultProjectType
    paymentTerms
    localOtNumberOfHours
    exeOtNumberOfHours
    projectNumberCustomisation {
      seperator
      first
      second
      third
    }
    useOneProjectNumber
    commonProjectNumber
    individualSuppliersSubAcc
    clientsSalesAccountNumber
    suppliersCostAccountNumber
    quoteNumberCustomisation {
      seperator
      first
      second
      third
    }
    useOneQuoteNumber
    commonQuoteNumber
    commonProjectGroupFlag
    commonProjectGroup
    restrictProjectGroup
    salesLedgerName
    purchasesLedgerName
    ledgerNames {
      bankProfileName
      bridgeBankAccountId
      number
      name
      label
    }
    quoteJsonDetails {
      name
      quoteType
      categories {
        Bucket
        Key
        identityId
      }
      subcategories {
        Bucket
        Key
        identityId
      }
      costline {
        Bucket
        Key
        identityId
      }
    }
    purchaseCount
    invoiceNumberPrefix
    poNumberPrefix
    emailTemplateArray {
      id
      language
      name
      subject
      body
    }
    billitPartyId
    billitApiKey
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnUpdateCompanySubscriptionVariables,
		APITypes.OnUpdateCompanySubscription
	>
export const onDeleteCompany =
	/* GraphQL */ `subscription OnDeleteCompany($filter: ModelSubscriptionCompanyFilterInput) {
  onDeleteCompany(filter: $filter) {
    id
    tenantId
    name
    email
    phone
    website
    registrationNumber
    vatNumber
    addressLine1
    addressLine2
    pdfPrimaryColor
    pdfSecondaryColor
    logoImage {
      bucket
      region
      key
      identityId
    }
    logoImage2 {
      bucket
      region
      key
      identityId
    }
    logoImage3 {
      bucket
      region
      key
      identityId
    }
    logoImage4 {
      bucket
      region
      key
      identityId
    }
    logoImageText
    logoImage2Text
    logoImage3Text
    logoImage4Text
    invoiceCount
    purchaseOrderInvoiceCount
    invoicingYear
    bank
    iban
    bic
    accountName
    bankProfileName
    bankProfileName2
    bank2
    iban2
    bic2
    accountName2
    bankProfileName3
    bank3
    iban3
    bic3
    accountName3
    bankProfileName4
    bank4
    iban4
    bic4
    accountName4
    bankProfileName5
    bank5
    iban5
    bic5
    accountName5
    accountCurrency
    country
    duplicateQuoteCounter
    exportInfo {
      exportDate
      user
    }
    companyEmailId
    createPurchaseRecap
    termsAndCondition1
    termsAndCondition2
    poTANDC1 {
      bucket
      region
      key
      identityId
    }
    soundProdTAndC1 {
      bucket
      region
      key
      identityId
    }
    soundProdTAndC2 {
      bucket
      region
      key
      identityId
    }
    editorialTAndC {
      bucket
      region
      key
      identityId
    }
    commercialTAndC {
      bucket
      region
      key
      identityId
    }
    setDesignTAndC {
      bucket
      region
      key
      identityId
    }
    wardrobeTAndC {
      bucket
      region
      key
      identityId
    }
    editorialEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    commercialEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    setDesignEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    wardrobeEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    digitalTAndC {
      bucket
      region
      key
      identityId
    }
    animationTAndC {
      bucket
      region
      key
      identityId
    }
    animationEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    frenchApfpTAndC1 {
      bucket
      region
      key
      identityId
    }
    frenchApfpTAndC2 {
      bucket
      region
      key
      identityId
    }
    blankQuoteTAndC {
      bucket
      region
      key
      identityId
    }
    blankQuoteEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    aicpTAndC {
      bucket
      region
      key
      identityId
    }
    purchaseTags {
      title
      color
    }
    favouriteProjects {
      id
      name
      selectedDate
    }
    teamCount
    subTeamCount
    projectCount {
      type
      count
      year
      name
    }
    projectGroupCount {
      type
      count
      year
      name
    }
    quoteCount {
      type
      count
      year
      name
    }
    quoteTemplateDetails {
      type
      quoteId
      parentTeamId
      parentSubTeamId
      quoteName
    }
    quoteAccountingCategoryAllow
    quoteAccountingCategory {
      name
    }
    quoteTertiaryCategoryAllow
    quoteTertiaryCategory {
      name
    }
    taxRateType
    salesAccNumberType
    salesAccByCostlineDetails {
      id
      EUName
      EUNumber
      InternationalName
      InternationalNumber
      LocalName
      LocalNumber
    }
    salesAccQuoteTypeDetails {
      type
      EUName
      EUNumber
      InternationalName
      InternationalNumber
      LocalName
      LocalNumber
    }
    aicpEUName
    aicpEUNumber
    aicpInternationalName
    aicpInternationalNumber
    aicpLocalName
    aicpLocalNumber
    apfpEUName
    apfpEUNumber
    apfpInternationalName
    apfpInternationalNumber
    apfpLocalName
    apfpLocalNumber
    photoEUName
    photoEUNumber
    photoInternationalName
    photoInternationalNumber
    photoLocalName
    photoLocalNumber
    postProdEUName
    postProdEUNumber
    postProdInternationalName
    postProdInternationalNumber
    postProdLocalName
    postProdLocalNumber
    vat20
    vat10
    specialEnglishInvoiceNote
    specialFrenchInvoiceNote
    costCategoriesFields {
      id
      name
    }
    costVatFields {
      number
      name
      text
    }
    miscAccNosFields {
      name
      number
      text
    }
    clientsSubAcc
    suppliersSubAcc
    userBridgeApiLoginDetails {
      uuid
      email
    }
    userBankingAutehticationDetails {
      access_token
      expires_at
      user {
        uuid
        email
      }
    }
    isLoggedIntoBanking
    lastUpdatedTransactionDate
    vatIntracom {
      type
      debitNumber
      debitName
      creditNumber
      creditName
    }
    sendCostlinesToReviewPage
    sendOverheadsToReviewPage
    activateDeliveryDate
    defaultProjectType
    paymentTerms
    localOtNumberOfHours
    exeOtNumberOfHours
    projectNumberCustomisation {
      seperator
      first
      second
      third
    }
    useOneProjectNumber
    commonProjectNumber
    individualSuppliersSubAcc
    clientsSalesAccountNumber
    suppliersCostAccountNumber
    quoteNumberCustomisation {
      seperator
      first
      second
      third
    }
    useOneQuoteNumber
    commonQuoteNumber
    commonProjectGroupFlag
    commonProjectGroup
    restrictProjectGroup
    salesLedgerName
    purchasesLedgerName
    ledgerNames {
      bankProfileName
      bridgeBankAccountId
      number
      name
      label
    }
    quoteJsonDetails {
      name
      quoteType
      categories {
        Bucket
        Key
        identityId
      }
      subcategories {
        Bucket
        Key
        identityId
      }
      costline {
        Bucket
        Key
        identityId
      }
    }
    purchaseCount
    invoiceNumberPrefix
    poNumberPrefix
    emailTemplateArray {
      id
      language
      name
      subject
      body
    }
    billitPartyId
    billitApiKey
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnDeleteCompanySubscriptionVariables,
		APITypes.OnDeleteCompanySubscription
	>
export const onCreateCompanyQuoteTemplate =
	/* GraphQL */ `subscription OnCreateCompanyQuoteTemplate(
  $filter: ModelSubscriptionCompanyQuoteTemplateFilterInput
) {
  onCreateCompanyQuoteTemplate(filter: $filter) {
    id
    tenantId
    quoteId
    teamIds
    subTeamIds
    name
    quoteType
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnCreateCompanyQuoteTemplateSubscriptionVariables,
		APITypes.OnCreateCompanyQuoteTemplateSubscription
	>
export const onUpdateCompanyQuoteTemplate =
	/* GraphQL */ `subscription OnUpdateCompanyQuoteTemplate(
  $filter: ModelSubscriptionCompanyQuoteTemplateFilterInput
) {
  onUpdateCompanyQuoteTemplate(filter: $filter) {
    id
    tenantId
    quoteId
    teamIds
    subTeamIds
    name
    quoteType
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnUpdateCompanyQuoteTemplateSubscriptionVariables,
		APITypes.OnUpdateCompanyQuoteTemplateSubscription
	>
export const onDeleteCompanyQuoteTemplate =
	/* GraphQL */ `subscription OnDeleteCompanyQuoteTemplate(
  $filter: ModelSubscriptionCompanyQuoteTemplateFilterInput
) {
  onDeleteCompanyQuoteTemplate(filter: $filter) {
    id
    tenantId
    quoteId
    teamIds
    subTeamIds
    name
    quoteType
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnDeleteCompanyQuoteTemplateSubscriptionVariables,
		APITypes.OnDeleteCompanyQuoteTemplateSubscription
	>
export const onCreateContact =
	/* GraphQL */ `subscription OnCreateContact($filter: ModelSubscriptionContactFilterInput) {
  onCreateContact(filter: $filter) {
    id
    tenantId
    activeFlag
    name
    idnumber
    vatNumber
    website
    phone
    firstName
    lastName
    email
    contactPhone
    contactDetails {
      id
      fullName
      email
      phone
    }
    line01
    line02
    city
    state
    postalCode
    country
    currency
    paymentTerms
    taxType
    taxRate
    thirdPartyAccounts
    note
    bank
    iban
    bic
    accountName
    clientSubAccount
    invoices {
      items {
        id
        tenantId
        proposalId
        quoteType
        activeFlag
        originalInvoiceId
        creditInvoiceGenerated
        archivedDate
        paidDate
        paymentStatus
        quoteName
        quoteNumber
        projectName
        projectNumber
        clientId
        contactId
        clientName
        contactName
        clientTaxType
        clientEmail
        clientAddress
        clientCountry
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        title
        invoiceNumber
        poNumber
        invoiceAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        clientNote
        isDetailed
        isClientTaxRate
        bankProfileNumber
        invoicesBankProfileName
        invoicesBank
        invoicesIban
        invoicesBic
        invoicesAccountName
        invoiceDate
        invoiceDueDate
        description
        creditComments
        invoiceType
        proposalsDraft {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
          salesAccNumberType
        }
        taxDetails {
          taxRate
          taxPercentage
          taxAmount
          taxableAmount
        }
        salesAccNumberType
        sectionDetails {
          type
          amount
        }
        sectionDetailsByQuote {
          type
          amount
        }
        sectionDetailsByAccSection {
          type
          amount
        }
        proposals {
          id
          tenantId
          activeFlag
          quoteId
          quoteType
          clientId
          contactId
          status
          noofInvoices
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          createdOn
          updatedOn
          poDate
          poName
          poAmount
          poCurrency
          poNotes
          poVersion
          prevStatus
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          _deleted
          _version
          _lastChangedAt
        }
        createdOn
        updatedOn
        uniqueTransactionId
        assignedTenantId
        assignedTenantName
        showBidLetter
        companyLogo
        lastExportedDate
        emailSent
        draftEmailData {
          toEmail
          toCC
          toBCC
          subject
          body
          template
        }
        emailHistory {
          date
          subject
        }
        billitInboxItemId
        billitPeppolStatus
        billitPeppolError
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedSubscription<
		APITypes.OnCreateContactSubscriptionVariables,
		APITypes.OnCreateContactSubscription
	>
export const onUpdateContact =
	/* GraphQL */ `subscription OnUpdateContact($filter: ModelSubscriptionContactFilterInput) {
  onUpdateContact(filter: $filter) {
    id
    tenantId
    activeFlag
    name
    idnumber
    vatNumber
    website
    phone
    firstName
    lastName
    email
    contactPhone
    contactDetails {
      id
      fullName
      email
      phone
    }
    line01
    line02
    city
    state
    postalCode
    country
    currency
    paymentTerms
    taxType
    taxRate
    thirdPartyAccounts
    note
    bank
    iban
    bic
    accountName
    clientSubAccount
    invoices {
      items {
        id
        tenantId
        proposalId
        quoteType
        activeFlag
        originalInvoiceId
        creditInvoiceGenerated
        archivedDate
        paidDate
        paymentStatus
        quoteName
        quoteNumber
        projectName
        projectNumber
        clientId
        contactId
        clientName
        contactName
        clientTaxType
        clientEmail
        clientAddress
        clientCountry
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        title
        invoiceNumber
        poNumber
        invoiceAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        clientNote
        isDetailed
        isClientTaxRate
        bankProfileNumber
        invoicesBankProfileName
        invoicesBank
        invoicesIban
        invoicesBic
        invoicesAccountName
        invoiceDate
        invoiceDueDate
        description
        creditComments
        invoiceType
        proposalsDraft {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
          salesAccNumberType
        }
        taxDetails {
          taxRate
          taxPercentage
          taxAmount
          taxableAmount
        }
        salesAccNumberType
        sectionDetails {
          type
          amount
        }
        sectionDetailsByQuote {
          type
          amount
        }
        sectionDetailsByAccSection {
          type
          amount
        }
        proposals {
          id
          tenantId
          activeFlag
          quoteId
          quoteType
          clientId
          contactId
          status
          noofInvoices
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          createdOn
          updatedOn
          poDate
          poName
          poAmount
          poCurrency
          poNotes
          poVersion
          prevStatus
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          _deleted
          _version
          _lastChangedAt
        }
        createdOn
        updatedOn
        uniqueTransactionId
        assignedTenantId
        assignedTenantName
        showBidLetter
        companyLogo
        lastExportedDate
        emailSent
        draftEmailData {
          toEmail
          toCC
          toBCC
          subject
          body
          template
        }
        emailHistory {
          date
          subject
        }
        billitInboxItemId
        billitPeppolStatus
        billitPeppolError
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedSubscription<
		APITypes.OnUpdateContactSubscriptionVariables,
		APITypes.OnUpdateContactSubscription
	>
export const onDeleteContact =
	/* GraphQL */ `subscription OnDeleteContact($filter: ModelSubscriptionContactFilterInput) {
  onDeleteContact(filter: $filter) {
    id
    tenantId
    activeFlag
    name
    idnumber
    vatNumber
    website
    phone
    firstName
    lastName
    email
    contactPhone
    contactDetails {
      id
      fullName
      email
      phone
    }
    line01
    line02
    city
    state
    postalCode
    country
    currency
    paymentTerms
    taxType
    taxRate
    thirdPartyAccounts
    note
    bank
    iban
    bic
    accountName
    clientSubAccount
    invoices {
      items {
        id
        tenantId
        proposalId
        quoteType
        activeFlag
        originalInvoiceId
        creditInvoiceGenerated
        archivedDate
        paidDate
        paymentStatus
        quoteName
        quoteNumber
        projectName
        projectNumber
        clientId
        contactId
        clientName
        contactName
        clientTaxType
        clientEmail
        clientAddress
        clientCountry
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        title
        invoiceNumber
        poNumber
        invoiceAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        clientNote
        isDetailed
        isClientTaxRate
        bankProfileNumber
        invoicesBankProfileName
        invoicesBank
        invoicesIban
        invoicesBic
        invoicesAccountName
        invoiceDate
        invoiceDueDate
        description
        creditComments
        invoiceType
        proposalsDraft {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
          salesAccNumberType
        }
        taxDetails {
          taxRate
          taxPercentage
          taxAmount
          taxableAmount
        }
        salesAccNumberType
        sectionDetails {
          type
          amount
        }
        sectionDetailsByQuote {
          type
          amount
        }
        sectionDetailsByAccSection {
          type
          amount
        }
        proposals {
          id
          tenantId
          activeFlag
          quoteId
          quoteType
          clientId
          contactId
          status
          noofInvoices
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          createdOn
          updatedOn
          poDate
          poName
          poAmount
          poCurrency
          poNotes
          poVersion
          prevStatus
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          _deleted
          _version
          _lastChangedAt
        }
        createdOn
        updatedOn
        uniqueTransactionId
        assignedTenantId
        assignedTenantName
        showBidLetter
        companyLogo
        lastExportedDate
        emailSent
        draftEmailData {
          toEmail
          toCC
          toBCC
          subject
          body
          template
        }
        emailHistory {
          date
          subject
        }
        billitInboxItemId
        billitPeppolStatus
        billitPeppolError
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedSubscription<
		APITypes.OnDeleteContactSubscriptionVariables,
		APITypes.OnDeleteContactSubscription
	>
export const onCreateCurrencyRate =
	/* GraphQL */ `subscription OnCreateCurrencyRate(
  $filter: ModelSubscriptionCurrencyRateFilterInput
) {
  onCreateCurrencyRate(filter: $filter) {
    id
    tenantId
    activeFlag
    base
    date
    rates {
      currencyName
      currencyRate
    }
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnCreateCurrencyRateSubscriptionVariables,
		APITypes.OnCreateCurrencyRateSubscription
	>
export const onUpdateCurrencyRate =
	/* GraphQL */ `subscription OnUpdateCurrencyRate(
  $filter: ModelSubscriptionCurrencyRateFilterInput
) {
  onUpdateCurrencyRate(filter: $filter) {
    id
    tenantId
    activeFlag
    base
    date
    rates {
      currencyName
      currencyRate
    }
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnUpdateCurrencyRateSubscriptionVariables,
		APITypes.OnUpdateCurrencyRateSubscription
	>
export const onDeleteCurrencyRate =
	/* GraphQL */ `subscription OnDeleteCurrencyRate(
  $filter: ModelSubscriptionCurrencyRateFilterInput
) {
  onDeleteCurrencyRate(filter: $filter) {
    id
    tenantId
    activeFlag
    base
    date
    rates {
      currencyName
      currencyRate
    }
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnDeleteCurrencyRateSubscriptionVariables,
		APITypes.OnDeleteCurrencyRateSubscription
	>
export const onCreateExportInfo =
	/* GraphQL */ `subscription OnCreateExportInfo(
  $filter: ModelSubscriptionExportInfoFilterInput
) {
  onCreateExportInfo(filter: $filter) {
    id
    tenantId
    activeFlag
    name
    exportDate
    exportType
    loggedLineId
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedSubscription<
		APITypes.OnCreateExportInfoSubscriptionVariables,
		APITypes.OnCreateExportInfoSubscription
	>
export const onUpdateExportInfo =
	/* GraphQL */ `subscription OnUpdateExportInfo(
  $filter: ModelSubscriptionExportInfoFilterInput
) {
  onUpdateExportInfo(filter: $filter) {
    id
    tenantId
    activeFlag
    name
    exportDate
    exportType
    loggedLineId
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedSubscription<
		APITypes.OnUpdateExportInfoSubscriptionVariables,
		APITypes.OnUpdateExportInfoSubscription
	>
export const onDeleteExportInfo =
	/* GraphQL */ `subscription OnDeleteExportInfo(
  $filter: ModelSubscriptionExportInfoFilterInput
) {
  onDeleteExportInfo(filter: $filter) {
    id
    tenantId
    activeFlag
    name
    exportDate
    exportType
    loggedLineId
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedSubscription<
		APITypes.OnDeleteExportInfoSubscriptionVariables,
		APITypes.OnDeleteExportInfoSubscription
	>
export const onCreateFilledCostlines =
	/* GraphQL */ `subscription OnCreateFilledCostlines(
  $filter: ModelSubscriptionFilledCostlinesFilterInput
) {
  onCreateFilledCostlines(filter: $filter) {
    id
    tenantId
    quoteId
    item
    item_fr
    quantity
    number
    shootNumber
    rate
    rateInEuros
    total
    overheadPercentage
    marginPercentage
    costlineUuid
    costLineType
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnCreateFilledCostlinesSubscriptionVariables,
		APITypes.OnCreateFilledCostlinesSubscription
	>
export const onUpdateFilledCostlines =
	/* GraphQL */ `subscription OnUpdateFilledCostlines(
  $filter: ModelSubscriptionFilledCostlinesFilterInput
) {
  onUpdateFilledCostlines(filter: $filter) {
    id
    tenantId
    quoteId
    item
    item_fr
    quantity
    number
    shootNumber
    rate
    rateInEuros
    total
    overheadPercentage
    marginPercentage
    costlineUuid
    costLineType
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnUpdateFilledCostlinesSubscriptionVariables,
		APITypes.OnUpdateFilledCostlinesSubscription
	>
export const onDeleteFilledCostlines =
	/* GraphQL */ `subscription OnDeleteFilledCostlines(
  $filter: ModelSubscriptionFilledCostlinesFilterInput
) {
  onDeleteFilledCostlines(filter: $filter) {
    id
    tenantId
    quoteId
    item
    item_fr
    quantity
    number
    shootNumber
    rate
    rateInEuros
    total
    overheadPercentage
    marginPercentage
    costlineUuid
    costLineType
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnDeleteFilledCostlinesSubscriptionVariables,
		APITypes.OnDeleteFilledCostlinesSubscription
	>
export const onCreateFreelancerBilling =
	/* GraphQL */ `subscription OnCreateFreelancerBilling(
  $filter: ModelSubscriptionFreelancerBillingFilterInput
) {
  onCreateFreelancerBilling(filter: $filter) {
    id
    tenantId
    projectId
    freelancerId
    projectFreelancerKey
    stripeInvoiceId
    stripeLineItemId
    stripeRefundId
    stripePriceId
    stripePriceAmount
    status
    chargedAt
    chargeScheduledAt
    chargeSchedulerName
    refundEligibleUntil
    refundedAt
    stripeCreditNoteId
    activeFlag
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnCreateFreelancerBillingSubscriptionVariables,
		APITypes.OnCreateFreelancerBillingSubscription
	>
export const onUpdateFreelancerBilling =
	/* GraphQL */ `subscription OnUpdateFreelancerBilling(
  $filter: ModelSubscriptionFreelancerBillingFilterInput
) {
  onUpdateFreelancerBilling(filter: $filter) {
    id
    tenantId
    projectId
    freelancerId
    projectFreelancerKey
    stripeInvoiceId
    stripeLineItemId
    stripeRefundId
    stripePriceId
    stripePriceAmount
    status
    chargedAt
    chargeScheduledAt
    chargeSchedulerName
    refundEligibleUntil
    refundedAt
    stripeCreditNoteId
    activeFlag
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnUpdateFreelancerBillingSubscriptionVariables,
		APITypes.OnUpdateFreelancerBillingSubscription
	>
export const onDeleteFreelancerBilling =
	/* GraphQL */ `subscription OnDeleteFreelancerBilling(
  $filter: ModelSubscriptionFreelancerBillingFilterInput
) {
  onDeleteFreelancerBilling(filter: $filter) {
    id
    tenantId
    projectId
    freelancerId
    projectFreelancerKey
    stripeInvoiceId
    stripeLineItemId
    stripeRefundId
    stripePriceId
    stripePriceAmount
    status
    chargedAt
    chargeScheduledAt
    chargeSchedulerName
    refundEligibleUntil
    refundedAt
    stripeCreditNoteId
    activeFlag
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnDeleteFreelancerBillingSubscriptionVariables,
		APITypes.OnDeleteFreelancerBillingSubscription
	>
export const onCreateFreelancers =
	/* GraphQL */ `subscription OnCreateFreelancers(
  $filter: ModelSubscriptionFreelancersFilterInput
) {
  onCreateFreelancers(filter: $filter) {
    id
    email
    name
    freelancerTenantId
    companyTenantId
    currentCompanyTenantId
    currentCompanyName
    profileImage {
      bucket
      region
      key
      identityId
    }
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnCreateFreelancersSubscriptionVariables,
		APITypes.OnCreateFreelancersSubscription
	>
export const onUpdateFreelancers =
	/* GraphQL */ `subscription OnUpdateFreelancers(
  $filter: ModelSubscriptionFreelancersFilterInput
) {
  onUpdateFreelancers(filter: $filter) {
    id
    email
    name
    freelancerTenantId
    companyTenantId
    currentCompanyTenantId
    currentCompanyName
    profileImage {
      bucket
      region
      key
      identityId
    }
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnUpdateFreelancersSubscriptionVariables,
		APITypes.OnUpdateFreelancersSubscription
	>
export const onDeleteFreelancers =
	/* GraphQL */ `subscription OnDeleteFreelancers(
  $filter: ModelSubscriptionFreelancersFilterInput
) {
  onDeleteFreelancers(filter: $filter) {
    id
    email
    name
    freelancerTenantId
    companyTenantId
    currentCompanyTenantId
    currentCompanyName
    profileImage {
      bucket
      region
      key
      identityId
    }
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnDeleteFreelancersSubscriptionVariables,
		APITypes.OnDeleteFreelancersSubscription
	>
export const onCreateInvoices =
	/* GraphQL */ `subscription OnCreateInvoices($filter: ModelSubscriptionInvoicesFilterInput) {
  onCreateInvoices(filter: $filter) {
    id
    tenantId
    proposalId
    quoteType
    activeFlag
    originalInvoiceId
    creditInvoiceGenerated
    archivedDate
    paidDate
    paymentStatus
    quoteName
    quoteNumber
    projectName
    projectNumber
    clientId
    contactId
    clientName
    contactName
    clientTaxType
    clientEmail
    clientAddress
    clientCountry
    clientIdNumber
    clientVatNumber
    clientCurrency
    clientTaxRate
    title
    invoiceNumber
    poNumber
    invoiceAmountPercentage
    amount
    amountAfterTax
    taxAmount
    balancePercentage
    balanceAmount
    clientNote
    isDetailed
    isClientTaxRate
    bankProfileNumber
    invoicesBankProfileName
    invoicesBank
    invoicesIban
    invoicesBic
    invoicesAccountName
    invoiceDate
    invoiceDueDate
    description
    creditComments
    invoiceType
    proposalsDraft {
      generated
      poNumber
      proposalAmountPercentage
      amount
      amountAfterTax
      taxAmount
      balancePercentage
      balanceAmount
      invoiceId
      invoiceDate
      invoiceDueDate
      description
      readyStatus
      taxDetails {
        taxRate
        taxPercentage
        taxAmount
        taxableAmount
      }
      salesAccNumberType
      sectionDetails {
        type
        amount
      }
      sectionDetailsByQuote {
        type
        amount
      }
      sectionDetailsByAccSection {
        type
        amount
      }
    }
    taxDetails {
      taxRate
      taxPercentage
      taxAmount
      taxableAmount
    }
    salesAccNumberType
    sectionDetails {
      type
      amount
    }
    sectionDetailsByQuote {
      type
      amount
    }
    sectionDetailsByAccSection {
      type
      amount
    }
    proposals {
      id
      tenantId
      activeFlag
      quoteId
      quoteType
      clientId
      contactId
      status
      noofInvoices
      quoteName
      quoteNumber
      projectName
      projectNumber
      clientTaxType
      clientName
      contactName
      clientEmail
      clientAddress
      clientCountry
      clientIdNumber
      clientVatNumber
      clientCurrency
      clientTaxRate
      paymentTerms
      total
      clientNote
      isDetailed
      isClientTaxRate
      bankProfileNumber
      proposalsBankProfileName
      proposalsBank
      proposalsIban
      proposalsBic
      proposalsAccountName
      drafts {
        generated
        poNumber
        proposalAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        invoiceId
        invoiceDate
        invoiceDueDate
        description
        readyStatus
        taxDetails {
          taxRate
          taxPercentage
          taxAmount
          taxableAmount
        }
        salesAccNumberType
        sectionDetails {
          type
          amount
        }
        sectionDetailsByQuote {
          type
          amount
        }
        sectionDetailsByAccSection {
          type
          amount
        }
      }
      quote {
        id
        name
        tenantId
        quoteType
        quoteVersion
        aiGenerationRunId
        aiGenerationStatus
        aiGenerationError
        aiGenerationStartedAt
        aiGenerationCompletedAt
        aiGeneratedByUserId
        blankQuoteType
        parentTeamId
        parentSubTeamId
        visibility
        quoteLanguage
        childFreelancers
        offlineIds
        activeFlag
        type
        mergedQuotes
        parentProjectId
        billLocation
        marginLabel
        overheadLabel
        marginAndOverheadLabel
        marginPercentage
        overheadPercentage
        exchangeRate
        localExchangeRate
        localOtNumberOfHours
        exeOtNumberOfHours
        marginVAT_rate
        marginAcc_section
        allowInternational
        freelancers
        parentCompanyId
        companyLogo
        maximizeMinimize
        provisionalColumn
        selectContactById
        clientId
        contactId
        clientName
        projectName
        agency
        agencyRepresentative
        director
        executiveProducer
        lineProducer
        numberOfShootingDays
        notes
        introduction
        shooting
        prep
        shootingCountry
        prelight
        casting
        crew
        buyouts
        locations
        studio
        artDepartment
        wardrobe
        equipment
        travel
        accommodation
        editing
        imagePostproduction
        soundPostproduction
        deliverables
        insurance
        quoteGuidelines
        excluded
        paymentTerms
        miscellaneous
        conclusion
        installment1Percentage
        installment1Date
        installment2Percentage
        installment2Date
        balancePercentage
        balanceDate
        isStarred
        isChecked
        isFinalized
        recapInfoComments
        contact
        quoteTotal {
          budgetSubTotal
          budgetGrandTotal
          budgetMargin
          budgetMarginPercentage
          budgetSeperateMargin
          budgetSeperateMarginPercentage
          budgetSeperateOverhead
          budgetSeperateOverheadPercentage
          provisionalSubTotal
          provisionalGrandTotal
          provisionalMargin
          provisionalMarginPercentage
          actualSubTotal
          actualGrandTotal
          actualMargin
          actualMarginPercentage
          purchaseSubTotal
          purchaseGrandTotal
          purchaseMargin
          purchaseMarginPercentage
          grandBudgetWithMarginTotal
          noMarginTotalPercentage
          subTotalBudgetWithMargin
          subTotalBudgetWithoutMargin
          subTotalBudgetWithMarginPercentage
        }
        quoteTotalDiscount {
          totalAfterDiscount
          totalDiscount
          budgetTotalDiscountOnMargin
          budgetTotalDiscountOnMarginPercentage
          budgetTotalDiscountPercentage
          provisionalTotalDiscountOnMargin
          provisionalTotalDiscountOnMarginPercentage
          provisionalTotalDiscountPercentage
          actualTotalDiscountOnMargin
          actualTotalDiscountOnMarginPercentage
          actualTotalDiscountPercentage
          purchaseTotalDiscountOnMargin
          purchaseTotalDiscountOnMarginPercentage
          purchaseTotalDiscountPercentage
        }
        discount {
          totalDiscount
          totalAfterDiscount
          totalDiscountOnMargin
          totalDiscountOnMarginPercentage
          totalDiscountPercentage
        }
        quoteNumber
        quoteAccountingCategory
        deliveryDate
        quoteTertiaryCategory
        exeLocation
        advertiserJobID
        brand
        jobName
        agencyJobID
        product
        advertiser
        productionJobID
        advertiserAddress
        productionCompany
        productionContact
        vfxCo
        vfxProducer
        editorialCo
        editorialProducer
        musicCo
        musicProducer
        agencyProducer
        agencyCreativeTeam
        prepDays
        buildAndStrikeDays
        preLight
        stageDays
        locationDays
        description
        service
        scope
        vhr
        billingAddress
        dateOfShoot
        photographer
        jobNumber
        photoLocation
        quoteProdValue1
        quoteProdValue2
        quoteProdValue3
        quoteProdValue4
        quoteProdValue5
        quoteProdValue6
        quoteProdValue7
        quoteProdValue8
        quoteProdValue9
        quoteProdValue10
        quoteProdValue11
        quoteProdValue12
        quoteProdValue13
        quoteProdValue14
        quoteProdValue15
        quoteProdValue16
        quoteProdValue17
        quoteProdValue18
        quoteProdValue19
        quoteProdValue20
        quoteProdValue21
        quoteProdValue22
        quoteProdValue23
        quoteProdValue24
        quoteProdValue25
        termsType
        termsSelection
        quoteCurrency
        exeQuoteCurrency
        marginCustomization
        pdfColumnCustomization
        pdfMiscCustomization
        summaryTableCustomization
        quoteHeaderLabel1
        quoteHeaderValue1
        quoteHeaderLabel2
        quoteHeaderValue2
        quoteHeaderLabel3
        quoteHeaderValue3
        quoteHeaderLabel4
        quoteHeaderValue4
        quoteHeaderLabel5
        quoteHeaderValue5
        quoteHeaderLabel6
        quoteHeaderValue6
        quoteHeaderLabel7
        quoteHeaderValue7
        quoteHeaderLabel8
        quoteHeaderValue8
        quoteHeaderLabel9
        quoteHeaderValue9
        quoteHeaderLabel10
        quoteHeaderValue10
        quoteHeaderLabel11
        quoteHeaderValue11
        productionNoteLabels
        budgetSections
        showCo2InSummary
        showCo2InPdf
        numberOfPrepDaysCo2
        numberOfShootDaysCo2
        numberOfPeopleOnSetCo2
        enableTravelCo2
        travelTypeCo2
        percentageOfCrewTravelCo2
        travelTypeLocation2Co2
        percentageOfCrewTravelLocation2Co2
        overtimeHours1Rate
        overtimeHours2Rate
        overtimeHours3Rate
        overtimeHours4Rate
        assignedTenantId
        assignedTenantName
        isExpired
        filledCostlineDetails {
          totalBudget
          totalCrewBudget
          totalPostProdBudget
          crewPrepNumberOfDays
          crewShootNumberOfDays
        }
        proposals {
          nextToken
        }
        createdOn
        updatedOn
        _deleted
        _version
        _lastChangedAt
      }
      invoices {
        items {
          id
          tenantId
          proposalId
          quoteType
          activeFlag
          originalInvoiceId
          creditInvoiceGenerated
          archivedDate
          paidDate
          paymentStatus
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientId
          contactId
          clientName
          contactName
          clientTaxType
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          title
          invoiceNumber
          poNumber
          invoiceAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          invoicesBankProfileName
          invoicesBank
          invoicesIban
          invoicesBic
          invoicesAccountName
          invoiceDate
          invoiceDueDate
          description
          creditComments
          invoiceType
          salesAccNumberType
          createdOn
          updatedOn
          uniqueTransactionId
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          lastExportedDate
          emailSent
          billitInboxItemId
          billitPeppolStatus
          billitPeppolError
          _deleted
          _version
          _lastChangedAt
        }
        nextToken
      }
      createdOn
      updatedOn
      poDate
      poName
      poAmount
      poCurrency
      poNotes
      poDocuments {
        bucket
        region
        key
        identityId
      }
      poVersion
      prevStatus
      assignedTenantId
      assignedTenantName
      showBidLetter
      companyLogo
      _deleted
      _version
      _lastChangedAt
    }
    createdOn
    updatedOn
    uniqueTransactionId
    assignedTenantId
    assignedTenantName
    showBidLetter
    companyLogo
    lastExportedDate
    emailSent
    draftEmailData {
      toEmail
      toCC
      toBCC
      subject
      body
      template
    }
    emailHistory {
      date
      subject
    }
    billitInboxItemId
    billitPeppolStatus
    billitPeppolError
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnCreateInvoicesSubscriptionVariables,
		APITypes.OnCreateInvoicesSubscription
	>
export const onUpdateInvoices =
	/* GraphQL */ `subscription OnUpdateInvoices($filter: ModelSubscriptionInvoicesFilterInput) {
  onUpdateInvoices(filter: $filter) {
    id
    tenantId
    proposalId
    quoteType
    activeFlag
    originalInvoiceId
    creditInvoiceGenerated
    archivedDate
    paidDate
    paymentStatus
    quoteName
    quoteNumber
    projectName
    projectNumber
    clientId
    contactId
    clientName
    contactName
    clientTaxType
    clientEmail
    clientAddress
    clientCountry
    clientIdNumber
    clientVatNumber
    clientCurrency
    clientTaxRate
    title
    invoiceNumber
    poNumber
    invoiceAmountPercentage
    amount
    amountAfterTax
    taxAmount
    balancePercentage
    balanceAmount
    clientNote
    isDetailed
    isClientTaxRate
    bankProfileNumber
    invoicesBankProfileName
    invoicesBank
    invoicesIban
    invoicesBic
    invoicesAccountName
    invoiceDate
    invoiceDueDate
    description
    creditComments
    invoiceType
    proposalsDraft {
      generated
      poNumber
      proposalAmountPercentage
      amount
      amountAfterTax
      taxAmount
      balancePercentage
      balanceAmount
      invoiceId
      invoiceDate
      invoiceDueDate
      description
      readyStatus
      taxDetails {
        taxRate
        taxPercentage
        taxAmount
        taxableAmount
      }
      salesAccNumberType
      sectionDetails {
        type
        amount
      }
      sectionDetailsByQuote {
        type
        amount
      }
      sectionDetailsByAccSection {
        type
        amount
      }
    }
    taxDetails {
      taxRate
      taxPercentage
      taxAmount
      taxableAmount
    }
    salesAccNumberType
    sectionDetails {
      type
      amount
    }
    sectionDetailsByQuote {
      type
      amount
    }
    sectionDetailsByAccSection {
      type
      amount
    }
    proposals {
      id
      tenantId
      activeFlag
      quoteId
      quoteType
      clientId
      contactId
      status
      noofInvoices
      quoteName
      quoteNumber
      projectName
      projectNumber
      clientTaxType
      clientName
      contactName
      clientEmail
      clientAddress
      clientCountry
      clientIdNumber
      clientVatNumber
      clientCurrency
      clientTaxRate
      paymentTerms
      total
      clientNote
      isDetailed
      isClientTaxRate
      bankProfileNumber
      proposalsBankProfileName
      proposalsBank
      proposalsIban
      proposalsBic
      proposalsAccountName
      drafts {
        generated
        poNumber
        proposalAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        invoiceId
        invoiceDate
        invoiceDueDate
        description
        readyStatus
        taxDetails {
          taxRate
          taxPercentage
          taxAmount
          taxableAmount
        }
        salesAccNumberType
        sectionDetails {
          type
          amount
        }
        sectionDetailsByQuote {
          type
          amount
        }
        sectionDetailsByAccSection {
          type
          amount
        }
      }
      quote {
        id
        name
        tenantId
        quoteType
        quoteVersion
        aiGenerationRunId
        aiGenerationStatus
        aiGenerationError
        aiGenerationStartedAt
        aiGenerationCompletedAt
        aiGeneratedByUserId
        blankQuoteType
        parentTeamId
        parentSubTeamId
        visibility
        quoteLanguage
        childFreelancers
        offlineIds
        activeFlag
        type
        mergedQuotes
        parentProjectId
        billLocation
        marginLabel
        overheadLabel
        marginAndOverheadLabel
        marginPercentage
        overheadPercentage
        exchangeRate
        localExchangeRate
        localOtNumberOfHours
        exeOtNumberOfHours
        marginVAT_rate
        marginAcc_section
        allowInternational
        freelancers
        parentCompanyId
        companyLogo
        maximizeMinimize
        provisionalColumn
        selectContactById
        clientId
        contactId
        clientName
        projectName
        agency
        agencyRepresentative
        director
        executiveProducer
        lineProducer
        numberOfShootingDays
        notes
        introduction
        shooting
        prep
        shootingCountry
        prelight
        casting
        crew
        buyouts
        locations
        studio
        artDepartment
        wardrobe
        equipment
        travel
        accommodation
        editing
        imagePostproduction
        soundPostproduction
        deliverables
        insurance
        quoteGuidelines
        excluded
        paymentTerms
        miscellaneous
        conclusion
        installment1Percentage
        installment1Date
        installment2Percentage
        installment2Date
        balancePercentage
        balanceDate
        isStarred
        isChecked
        isFinalized
        recapInfoComments
        contact
        quoteTotal {
          budgetSubTotal
          budgetGrandTotal
          budgetMargin
          budgetMarginPercentage
          budgetSeperateMargin
          budgetSeperateMarginPercentage
          budgetSeperateOverhead
          budgetSeperateOverheadPercentage
          provisionalSubTotal
          provisionalGrandTotal
          provisionalMargin
          provisionalMarginPercentage
          actualSubTotal
          actualGrandTotal
          actualMargin
          actualMarginPercentage
          purchaseSubTotal
          purchaseGrandTotal
          purchaseMargin
          purchaseMarginPercentage
          grandBudgetWithMarginTotal
          noMarginTotalPercentage
          subTotalBudgetWithMargin
          subTotalBudgetWithoutMargin
          subTotalBudgetWithMarginPercentage
        }
        quoteTotalDiscount {
          totalAfterDiscount
          totalDiscount
          budgetTotalDiscountOnMargin
          budgetTotalDiscountOnMarginPercentage
          budgetTotalDiscountPercentage
          provisionalTotalDiscountOnMargin
          provisionalTotalDiscountOnMarginPercentage
          provisionalTotalDiscountPercentage
          actualTotalDiscountOnMargin
          actualTotalDiscountOnMarginPercentage
          actualTotalDiscountPercentage
          purchaseTotalDiscountOnMargin
          purchaseTotalDiscountOnMarginPercentage
          purchaseTotalDiscountPercentage
        }
        discount {
          totalDiscount
          totalAfterDiscount
          totalDiscountOnMargin
          totalDiscountOnMarginPercentage
          totalDiscountPercentage
        }
        quoteNumber
        quoteAccountingCategory
        deliveryDate
        quoteTertiaryCategory
        exeLocation
        advertiserJobID
        brand
        jobName
        agencyJobID
        product
        advertiser
        productionJobID
        advertiserAddress
        productionCompany
        productionContact
        vfxCo
        vfxProducer
        editorialCo
        editorialProducer
        musicCo
        musicProducer
        agencyProducer
        agencyCreativeTeam
        prepDays
        buildAndStrikeDays
        preLight
        stageDays
        locationDays
        description
        service
        scope
        vhr
        billingAddress
        dateOfShoot
        photographer
        jobNumber
        photoLocation
        quoteProdValue1
        quoteProdValue2
        quoteProdValue3
        quoteProdValue4
        quoteProdValue5
        quoteProdValue6
        quoteProdValue7
        quoteProdValue8
        quoteProdValue9
        quoteProdValue10
        quoteProdValue11
        quoteProdValue12
        quoteProdValue13
        quoteProdValue14
        quoteProdValue15
        quoteProdValue16
        quoteProdValue17
        quoteProdValue18
        quoteProdValue19
        quoteProdValue20
        quoteProdValue21
        quoteProdValue22
        quoteProdValue23
        quoteProdValue24
        quoteProdValue25
        termsType
        termsSelection
        quoteCurrency
        exeQuoteCurrency
        marginCustomization
        pdfColumnCustomization
        pdfMiscCustomization
        summaryTableCustomization
        quoteHeaderLabel1
        quoteHeaderValue1
        quoteHeaderLabel2
        quoteHeaderValue2
        quoteHeaderLabel3
        quoteHeaderValue3
        quoteHeaderLabel4
        quoteHeaderValue4
        quoteHeaderLabel5
        quoteHeaderValue5
        quoteHeaderLabel6
        quoteHeaderValue6
        quoteHeaderLabel7
        quoteHeaderValue7
        quoteHeaderLabel8
        quoteHeaderValue8
        quoteHeaderLabel9
        quoteHeaderValue9
        quoteHeaderLabel10
        quoteHeaderValue10
        quoteHeaderLabel11
        quoteHeaderValue11
        productionNoteLabels
        budgetSections
        showCo2InSummary
        showCo2InPdf
        numberOfPrepDaysCo2
        numberOfShootDaysCo2
        numberOfPeopleOnSetCo2
        enableTravelCo2
        travelTypeCo2
        percentageOfCrewTravelCo2
        travelTypeLocation2Co2
        percentageOfCrewTravelLocation2Co2
        overtimeHours1Rate
        overtimeHours2Rate
        overtimeHours3Rate
        overtimeHours4Rate
        assignedTenantId
        assignedTenantName
        isExpired
        filledCostlineDetails {
          totalBudget
          totalCrewBudget
          totalPostProdBudget
          crewPrepNumberOfDays
          crewShootNumberOfDays
        }
        proposals {
          nextToken
        }
        createdOn
        updatedOn
        _deleted
        _version
        _lastChangedAt
      }
      invoices {
        items {
          id
          tenantId
          proposalId
          quoteType
          activeFlag
          originalInvoiceId
          creditInvoiceGenerated
          archivedDate
          paidDate
          paymentStatus
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientId
          contactId
          clientName
          contactName
          clientTaxType
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          title
          invoiceNumber
          poNumber
          invoiceAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          invoicesBankProfileName
          invoicesBank
          invoicesIban
          invoicesBic
          invoicesAccountName
          invoiceDate
          invoiceDueDate
          description
          creditComments
          invoiceType
          salesAccNumberType
          createdOn
          updatedOn
          uniqueTransactionId
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          lastExportedDate
          emailSent
          billitInboxItemId
          billitPeppolStatus
          billitPeppolError
          _deleted
          _version
          _lastChangedAt
        }
        nextToken
      }
      createdOn
      updatedOn
      poDate
      poName
      poAmount
      poCurrency
      poNotes
      poDocuments {
        bucket
        region
        key
        identityId
      }
      poVersion
      prevStatus
      assignedTenantId
      assignedTenantName
      showBidLetter
      companyLogo
      _deleted
      _version
      _lastChangedAt
    }
    createdOn
    updatedOn
    uniqueTransactionId
    assignedTenantId
    assignedTenantName
    showBidLetter
    companyLogo
    lastExportedDate
    emailSent
    draftEmailData {
      toEmail
      toCC
      toBCC
      subject
      body
      template
    }
    emailHistory {
      date
      subject
    }
    billitInboxItemId
    billitPeppolStatus
    billitPeppolError
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnUpdateInvoicesSubscriptionVariables,
		APITypes.OnUpdateInvoicesSubscription
	>
export const onDeleteInvoices =
	/* GraphQL */ `subscription OnDeleteInvoices($filter: ModelSubscriptionInvoicesFilterInput) {
  onDeleteInvoices(filter: $filter) {
    id
    tenantId
    proposalId
    quoteType
    activeFlag
    originalInvoiceId
    creditInvoiceGenerated
    archivedDate
    paidDate
    paymentStatus
    quoteName
    quoteNumber
    projectName
    projectNumber
    clientId
    contactId
    clientName
    contactName
    clientTaxType
    clientEmail
    clientAddress
    clientCountry
    clientIdNumber
    clientVatNumber
    clientCurrency
    clientTaxRate
    title
    invoiceNumber
    poNumber
    invoiceAmountPercentage
    amount
    amountAfterTax
    taxAmount
    balancePercentage
    balanceAmount
    clientNote
    isDetailed
    isClientTaxRate
    bankProfileNumber
    invoicesBankProfileName
    invoicesBank
    invoicesIban
    invoicesBic
    invoicesAccountName
    invoiceDate
    invoiceDueDate
    description
    creditComments
    invoiceType
    proposalsDraft {
      generated
      poNumber
      proposalAmountPercentage
      amount
      amountAfterTax
      taxAmount
      balancePercentage
      balanceAmount
      invoiceId
      invoiceDate
      invoiceDueDate
      description
      readyStatus
      taxDetails {
        taxRate
        taxPercentage
        taxAmount
        taxableAmount
      }
      salesAccNumberType
      sectionDetails {
        type
        amount
      }
      sectionDetailsByQuote {
        type
        amount
      }
      sectionDetailsByAccSection {
        type
        amount
      }
    }
    taxDetails {
      taxRate
      taxPercentage
      taxAmount
      taxableAmount
    }
    salesAccNumberType
    sectionDetails {
      type
      amount
    }
    sectionDetailsByQuote {
      type
      amount
    }
    sectionDetailsByAccSection {
      type
      amount
    }
    proposals {
      id
      tenantId
      activeFlag
      quoteId
      quoteType
      clientId
      contactId
      status
      noofInvoices
      quoteName
      quoteNumber
      projectName
      projectNumber
      clientTaxType
      clientName
      contactName
      clientEmail
      clientAddress
      clientCountry
      clientIdNumber
      clientVatNumber
      clientCurrency
      clientTaxRate
      paymentTerms
      total
      clientNote
      isDetailed
      isClientTaxRate
      bankProfileNumber
      proposalsBankProfileName
      proposalsBank
      proposalsIban
      proposalsBic
      proposalsAccountName
      drafts {
        generated
        poNumber
        proposalAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        invoiceId
        invoiceDate
        invoiceDueDate
        description
        readyStatus
        taxDetails {
          taxRate
          taxPercentage
          taxAmount
          taxableAmount
        }
        salesAccNumberType
        sectionDetails {
          type
          amount
        }
        sectionDetailsByQuote {
          type
          amount
        }
        sectionDetailsByAccSection {
          type
          amount
        }
      }
      quote {
        id
        name
        tenantId
        quoteType
        quoteVersion
        aiGenerationRunId
        aiGenerationStatus
        aiGenerationError
        aiGenerationStartedAt
        aiGenerationCompletedAt
        aiGeneratedByUserId
        blankQuoteType
        parentTeamId
        parentSubTeamId
        visibility
        quoteLanguage
        childFreelancers
        offlineIds
        activeFlag
        type
        mergedQuotes
        parentProjectId
        billLocation
        marginLabel
        overheadLabel
        marginAndOverheadLabel
        marginPercentage
        overheadPercentage
        exchangeRate
        localExchangeRate
        localOtNumberOfHours
        exeOtNumberOfHours
        marginVAT_rate
        marginAcc_section
        allowInternational
        freelancers
        parentCompanyId
        companyLogo
        maximizeMinimize
        provisionalColumn
        selectContactById
        clientId
        contactId
        clientName
        projectName
        agency
        agencyRepresentative
        director
        executiveProducer
        lineProducer
        numberOfShootingDays
        notes
        introduction
        shooting
        prep
        shootingCountry
        prelight
        casting
        crew
        buyouts
        locations
        studio
        artDepartment
        wardrobe
        equipment
        travel
        accommodation
        editing
        imagePostproduction
        soundPostproduction
        deliverables
        insurance
        quoteGuidelines
        excluded
        paymentTerms
        miscellaneous
        conclusion
        installment1Percentage
        installment1Date
        installment2Percentage
        installment2Date
        balancePercentage
        balanceDate
        isStarred
        isChecked
        isFinalized
        recapInfoComments
        contact
        quoteTotal {
          budgetSubTotal
          budgetGrandTotal
          budgetMargin
          budgetMarginPercentage
          budgetSeperateMargin
          budgetSeperateMarginPercentage
          budgetSeperateOverhead
          budgetSeperateOverheadPercentage
          provisionalSubTotal
          provisionalGrandTotal
          provisionalMargin
          provisionalMarginPercentage
          actualSubTotal
          actualGrandTotal
          actualMargin
          actualMarginPercentage
          purchaseSubTotal
          purchaseGrandTotal
          purchaseMargin
          purchaseMarginPercentage
          grandBudgetWithMarginTotal
          noMarginTotalPercentage
          subTotalBudgetWithMargin
          subTotalBudgetWithoutMargin
          subTotalBudgetWithMarginPercentage
        }
        quoteTotalDiscount {
          totalAfterDiscount
          totalDiscount
          budgetTotalDiscountOnMargin
          budgetTotalDiscountOnMarginPercentage
          budgetTotalDiscountPercentage
          provisionalTotalDiscountOnMargin
          provisionalTotalDiscountOnMarginPercentage
          provisionalTotalDiscountPercentage
          actualTotalDiscountOnMargin
          actualTotalDiscountOnMarginPercentage
          actualTotalDiscountPercentage
          purchaseTotalDiscountOnMargin
          purchaseTotalDiscountOnMarginPercentage
          purchaseTotalDiscountPercentage
        }
        discount {
          totalDiscount
          totalAfterDiscount
          totalDiscountOnMargin
          totalDiscountOnMarginPercentage
          totalDiscountPercentage
        }
        quoteNumber
        quoteAccountingCategory
        deliveryDate
        quoteTertiaryCategory
        exeLocation
        advertiserJobID
        brand
        jobName
        agencyJobID
        product
        advertiser
        productionJobID
        advertiserAddress
        productionCompany
        productionContact
        vfxCo
        vfxProducer
        editorialCo
        editorialProducer
        musicCo
        musicProducer
        agencyProducer
        agencyCreativeTeam
        prepDays
        buildAndStrikeDays
        preLight
        stageDays
        locationDays
        description
        service
        scope
        vhr
        billingAddress
        dateOfShoot
        photographer
        jobNumber
        photoLocation
        quoteProdValue1
        quoteProdValue2
        quoteProdValue3
        quoteProdValue4
        quoteProdValue5
        quoteProdValue6
        quoteProdValue7
        quoteProdValue8
        quoteProdValue9
        quoteProdValue10
        quoteProdValue11
        quoteProdValue12
        quoteProdValue13
        quoteProdValue14
        quoteProdValue15
        quoteProdValue16
        quoteProdValue17
        quoteProdValue18
        quoteProdValue19
        quoteProdValue20
        quoteProdValue21
        quoteProdValue22
        quoteProdValue23
        quoteProdValue24
        quoteProdValue25
        termsType
        termsSelection
        quoteCurrency
        exeQuoteCurrency
        marginCustomization
        pdfColumnCustomization
        pdfMiscCustomization
        summaryTableCustomization
        quoteHeaderLabel1
        quoteHeaderValue1
        quoteHeaderLabel2
        quoteHeaderValue2
        quoteHeaderLabel3
        quoteHeaderValue3
        quoteHeaderLabel4
        quoteHeaderValue4
        quoteHeaderLabel5
        quoteHeaderValue5
        quoteHeaderLabel6
        quoteHeaderValue6
        quoteHeaderLabel7
        quoteHeaderValue7
        quoteHeaderLabel8
        quoteHeaderValue8
        quoteHeaderLabel9
        quoteHeaderValue9
        quoteHeaderLabel10
        quoteHeaderValue10
        quoteHeaderLabel11
        quoteHeaderValue11
        productionNoteLabels
        budgetSections
        showCo2InSummary
        showCo2InPdf
        numberOfPrepDaysCo2
        numberOfShootDaysCo2
        numberOfPeopleOnSetCo2
        enableTravelCo2
        travelTypeCo2
        percentageOfCrewTravelCo2
        travelTypeLocation2Co2
        percentageOfCrewTravelLocation2Co2
        overtimeHours1Rate
        overtimeHours2Rate
        overtimeHours3Rate
        overtimeHours4Rate
        assignedTenantId
        assignedTenantName
        isExpired
        filledCostlineDetails {
          totalBudget
          totalCrewBudget
          totalPostProdBudget
          crewPrepNumberOfDays
          crewShootNumberOfDays
        }
        proposals {
          nextToken
        }
        createdOn
        updatedOn
        _deleted
        _version
        _lastChangedAt
      }
      invoices {
        items {
          id
          tenantId
          proposalId
          quoteType
          activeFlag
          originalInvoiceId
          creditInvoiceGenerated
          archivedDate
          paidDate
          paymentStatus
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientId
          contactId
          clientName
          contactName
          clientTaxType
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          title
          invoiceNumber
          poNumber
          invoiceAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          invoicesBankProfileName
          invoicesBank
          invoicesIban
          invoicesBic
          invoicesAccountName
          invoiceDate
          invoiceDueDate
          description
          creditComments
          invoiceType
          salesAccNumberType
          createdOn
          updatedOn
          uniqueTransactionId
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          lastExportedDate
          emailSent
          billitInboxItemId
          billitPeppolStatus
          billitPeppolError
          _deleted
          _version
          _lastChangedAt
        }
        nextToken
      }
      createdOn
      updatedOn
      poDate
      poName
      poAmount
      poCurrency
      poNotes
      poDocuments {
        bucket
        region
        key
        identityId
      }
      poVersion
      prevStatus
      assignedTenantId
      assignedTenantName
      showBidLetter
      companyLogo
      _deleted
      _version
      _lastChangedAt
    }
    createdOn
    updatedOn
    uniqueTransactionId
    assignedTenantId
    assignedTenantName
    showBidLetter
    companyLogo
    lastExportedDate
    emailSent
    draftEmailData {
      toEmail
      toCC
      toBCC
      subject
      body
      template
    }
    emailHistory {
      date
      subject
    }
    billitInboxItemId
    billitPeppolStatus
    billitPeppolError
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnDeleteInvoicesSubscriptionVariables,
		APITypes.OnDeleteInvoicesSubscription
	>
export const onCreateLlmDetails =
	/* GraphQL */ `subscription OnCreateLlmDetails(
  $filter: ModelSubscriptionLlmDetailsFilterInput
) {
  onCreateLlmDetails(filter: $filter) {
    id
    tenantId
    quoteId
    systemPrompt
    userPrompt
    temperature
    maxTokens
    generatedOutput
    generatedPromptQuoteKey
    runType
    runStatus
    runTypeStatus
    auditS3Key
    modelId
    inputTokens
    outputTokens
    totalTokens
    estimatedCostUsd
    startedAt
    completedAt
    errorCode
    errorMessage
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnCreateLlmDetailsSubscriptionVariables,
		APITypes.OnCreateLlmDetailsSubscription
	>
export const onUpdateLlmDetails =
	/* GraphQL */ `subscription OnUpdateLlmDetails(
  $filter: ModelSubscriptionLlmDetailsFilterInput
) {
  onUpdateLlmDetails(filter: $filter) {
    id
    tenantId
    quoteId
    systemPrompt
    userPrompt
    temperature
    maxTokens
    generatedOutput
    generatedPromptQuoteKey
    runType
    runStatus
    runTypeStatus
    auditS3Key
    modelId
    inputTokens
    outputTokens
    totalTokens
    estimatedCostUsd
    startedAt
    completedAt
    errorCode
    errorMessage
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnUpdateLlmDetailsSubscriptionVariables,
		APITypes.OnUpdateLlmDetailsSubscription
	>
export const onDeleteLlmDetails =
	/* GraphQL */ `subscription OnDeleteLlmDetails(
  $filter: ModelSubscriptionLlmDetailsFilterInput
) {
  onDeleteLlmDetails(filter: $filter) {
    id
    tenantId
    quoteId
    systemPrompt
    userPrompt
    temperature
    maxTokens
    generatedOutput
    generatedPromptQuoteKey
    runType
    runStatus
    runTypeStatus
    auditS3Key
    modelId
    inputTokens
    outputTokens
    totalTokens
    estimatedCostUsd
    startedAt
    completedAt
    errorCode
    errorMessage
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnDeleteLlmDetailsSubscriptionVariables,
		APITypes.OnDeleteLlmDetailsSubscription
	>
export const onCreatePreparePurchase =
	/* GraphQL */ `subscription OnCreatePreparePurchase(
  $filter: ModelSubscriptionPreparePurchaseFilterInput
) {
  onCreatePreparePurchase(filter: $filter) {
    id
    tenantId
    activeFlag
    uniqueTransactionId
    flag
    invoiceName
    ocrInvoiceName
    fileName
    ocrFileName
    invoiceDate
    ocrInvoiceDate
    paymentDate
    ocrPaymentDate
    paymentStatus
    preparePurchasePaidDate
    supplier
    ocrSupplier
    po
    ocrPO
    costlineName
    costlineName_fr
    projectName
    totalAmount
    taxAmount
    netAmountDetails {
      netAmount
      category
      projectId
      projectName
      projectNumber
      costlineId
      costlineName
      costlineName_fr
    }
    taxAmountDetails {
      taxAmount
      vatAccount
      vatIntracom
    }
    netAmount
    ocrTotalAmount
    ocrTaxAmount
    ocrNetAmount
    currency
    ocrCurrency
    type
    status
    currentPage
    prevPage
    archivedDate
    category
    ocrCategory
    note
    ocrNote
    invoiceDocuments {
      bucket
      region
      key
      identityId
    }
    poId
    quoteId
    supplierId
    costlineId
    projectId
    ocrStatus
    vatAccount
    ocrData {
      bucket
      region
      key
      identityId
    }
    invoiceKey
    paymentMethods
    vatIntracom
    bankAccountNumber
    paymentReference
    paymentReferenceType
    bankAccountName
    supplierAccountingNumber
    supplierAccountingName
    projectNumber
    quoteNumber
    lastExportedDate
    preparePurchaseToPayDate
    fullPurchaseNumber
    bridgePaymentLinkId
    billitInboxItemId
    billitPeppolFileId
    billitSenderPeppolId
    billitImportDate
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnCreatePreparePurchaseSubscriptionVariables,
		APITypes.OnCreatePreparePurchaseSubscription
	>
export const onUpdatePreparePurchase =
	/* GraphQL */ `subscription OnUpdatePreparePurchase(
  $filter: ModelSubscriptionPreparePurchaseFilterInput
) {
  onUpdatePreparePurchase(filter: $filter) {
    id
    tenantId
    activeFlag
    uniqueTransactionId
    flag
    invoiceName
    ocrInvoiceName
    fileName
    ocrFileName
    invoiceDate
    ocrInvoiceDate
    paymentDate
    ocrPaymentDate
    paymentStatus
    preparePurchasePaidDate
    supplier
    ocrSupplier
    po
    ocrPO
    costlineName
    costlineName_fr
    projectName
    totalAmount
    taxAmount
    netAmountDetails {
      netAmount
      category
      projectId
      projectName
      projectNumber
      costlineId
      costlineName
      costlineName_fr
    }
    taxAmountDetails {
      taxAmount
      vatAccount
      vatIntracom
    }
    netAmount
    ocrTotalAmount
    ocrTaxAmount
    ocrNetAmount
    currency
    ocrCurrency
    type
    status
    currentPage
    prevPage
    archivedDate
    category
    ocrCategory
    note
    ocrNote
    invoiceDocuments {
      bucket
      region
      key
      identityId
    }
    poId
    quoteId
    supplierId
    costlineId
    projectId
    ocrStatus
    vatAccount
    ocrData {
      bucket
      region
      key
      identityId
    }
    invoiceKey
    paymentMethods
    vatIntracom
    bankAccountNumber
    paymentReference
    paymentReferenceType
    bankAccountName
    supplierAccountingNumber
    supplierAccountingName
    projectNumber
    quoteNumber
    lastExportedDate
    preparePurchaseToPayDate
    fullPurchaseNumber
    bridgePaymentLinkId
    billitInboxItemId
    billitPeppolFileId
    billitSenderPeppolId
    billitImportDate
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnUpdatePreparePurchaseSubscriptionVariables,
		APITypes.OnUpdatePreparePurchaseSubscription
	>
export const onDeletePreparePurchase =
	/* GraphQL */ `subscription OnDeletePreparePurchase(
  $filter: ModelSubscriptionPreparePurchaseFilterInput
) {
  onDeletePreparePurchase(filter: $filter) {
    id
    tenantId
    activeFlag
    uniqueTransactionId
    flag
    invoiceName
    ocrInvoiceName
    fileName
    ocrFileName
    invoiceDate
    ocrInvoiceDate
    paymentDate
    ocrPaymentDate
    paymentStatus
    preparePurchasePaidDate
    supplier
    ocrSupplier
    po
    ocrPO
    costlineName
    costlineName_fr
    projectName
    totalAmount
    taxAmount
    netAmountDetails {
      netAmount
      category
      projectId
      projectName
      projectNumber
      costlineId
      costlineName
      costlineName_fr
    }
    taxAmountDetails {
      taxAmount
      vatAccount
      vatIntracom
    }
    netAmount
    ocrTotalAmount
    ocrTaxAmount
    ocrNetAmount
    currency
    ocrCurrency
    type
    status
    currentPage
    prevPage
    archivedDate
    category
    ocrCategory
    note
    ocrNote
    invoiceDocuments {
      bucket
      region
      key
      identityId
    }
    poId
    quoteId
    supplierId
    costlineId
    projectId
    ocrStatus
    vatAccount
    ocrData {
      bucket
      region
      key
      identityId
    }
    invoiceKey
    paymentMethods
    vatIntracom
    bankAccountNumber
    paymentReference
    paymentReferenceType
    bankAccountName
    supplierAccountingNumber
    supplierAccountingName
    projectNumber
    quoteNumber
    lastExportedDate
    preparePurchaseToPayDate
    fullPurchaseNumber
    bridgePaymentLinkId
    billitInboxItemId
    billitPeppolFileId
    billitSenderPeppolId
    billitImportDate
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnDeletePreparePurchaseSubscriptionVariables,
		APITypes.OnDeletePreparePurchaseSubscription
	>
export const onCreateProjects =
	/* GraphQL */ `subscription OnCreateProjects($filter: ModelSubscriptionProjectsFilterInput) {
  onCreateProjects(filter: $filter) {
    id
    name
    tenantId
    freelancers
    childFreelancers
    offlineIds
    parentProjectId
    parentClientId
    activeFlag
    type
    parentTeamId
    parentSubTeamId
    isSubTeam
    projectType
    projectGroup
    parentCompanyId
    projectNumber
    subTeamCount
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnCreateProjectsSubscriptionVariables,
		APITypes.OnCreateProjectsSubscription
	>
export const onUpdateProjects =
	/* GraphQL */ `subscription OnUpdateProjects($filter: ModelSubscriptionProjectsFilterInput) {
  onUpdateProjects(filter: $filter) {
    id
    name
    tenantId
    freelancers
    childFreelancers
    offlineIds
    parentProjectId
    parentClientId
    activeFlag
    type
    parentTeamId
    parentSubTeamId
    isSubTeam
    projectType
    projectGroup
    parentCompanyId
    projectNumber
    subTeamCount
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnUpdateProjectsSubscriptionVariables,
		APITypes.OnUpdateProjectsSubscription
	>
export const onDeleteProjects =
	/* GraphQL */ `subscription OnDeleteProjects($filter: ModelSubscriptionProjectsFilterInput) {
  onDeleteProjects(filter: $filter) {
    id
    name
    tenantId
    freelancers
    childFreelancers
    offlineIds
    parentProjectId
    parentClientId
    activeFlag
    type
    parentTeamId
    parentSubTeamId
    isSubTeam
    projectType
    projectGroup
    parentCompanyId
    projectNumber
    subTeamCount
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnDeleteProjectsSubscriptionVariables,
		APITypes.OnDeleteProjectsSubscription
	>
export const onCreateProposals =
	/* GraphQL */ `subscription OnCreateProposals($filter: ModelSubscriptionProposalsFilterInput) {
  onCreateProposals(filter: $filter) {
    id
    tenantId
    activeFlag
    quoteId
    quoteType
    clientId
    contactId
    status
    noofInvoices
    quoteName
    quoteNumber
    projectName
    projectNumber
    clientTaxType
    clientName
    contactName
    clientEmail
    clientAddress
    clientCountry
    clientIdNumber
    clientVatNumber
    clientCurrency
    clientTaxRate
    paymentTerms
    total
    clientNote
    isDetailed
    isClientTaxRate
    bankProfileNumber
    proposalsBankProfileName
    proposalsBank
    proposalsIban
    proposalsBic
    proposalsAccountName
    drafts {
      generated
      poNumber
      proposalAmountPercentage
      amount
      amountAfterTax
      taxAmount
      balancePercentage
      balanceAmount
      invoiceId
      invoiceDate
      invoiceDueDate
      description
      readyStatus
      taxDetails {
        taxRate
        taxPercentage
        taxAmount
        taxableAmount
      }
      salesAccNumberType
      sectionDetails {
        type
        amount
      }
      sectionDetailsByQuote {
        type
        amount
      }
      sectionDetailsByAccSection {
        type
        amount
      }
    }
    quote {
      id
      name
      tenantId
      quoteType
      quoteVersion
      aiGenerationRunId
      aiGenerationStatus
      aiGenerationError
      aiGenerationStartedAt
      aiGenerationCompletedAt
      aiGeneratedByUserId
      blankQuoteType
      parentTeamId
      parentSubTeamId
      visibility
      quoteLanguage
      childFreelancers
      offlineIds
      activeFlag
      type
      mergedQuotes
      parentProjectId
      billLocation
      marginLabel
      overheadLabel
      marginAndOverheadLabel
      marginPercentage
      overheadPercentage
      exchangeRate
      localExchangeRate
      localOtNumberOfHours
      exeOtNumberOfHours
      marginVAT_rate
      marginAcc_section
      allowInternational
      freelancers
      parentCompanyId
      companyLogo
      maximizeMinimize
      provisionalColumn
      selectContactById
      clientId
      contactId
      clientName
      projectName
      agency
      agencyRepresentative
      director
      executiveProducer
      lineProducer
      numberOfShootingDays
      notes
      introduction
      shooting
      prep
      shootingCountry
      prelight
      casting
      crew
      buyouts
      locations
      studio
      artDepartment
      wardrobe
      equipment
      travel
      accommodation
      editing
      imagePostproduction
      soundPostproduction
      deliverables
      insurance
      quoteGuidelines
      excluded
      paymentTerms
      miscellaneous
      conclusion
      installment1Percentage
      installment1Date
      installment2Percentage
      installment2Date
      balancePercentage
      balanceDate
      isStarred
      isChecked
      isFinalized
      recapInfoComments
      contact
      quoteTotal {
        budgetSubTotal
        budgetGrandTotal
        budgetMargin
        budgetMarginPercentage
        budgetSeperateMargin
        budgetSeperateMarginPercentage
        budgetSeperateOverhead
        budgetSeperateOverheadPercentage
        provisionalSubTotal
        provisionalGrandTotal
        provisionalMargin
        provisionalMarginPercentage
        actualSubTotal
        actualGrandTotal
        actualMargin
        actualMarginPercentage
        purchaseSubTotal
        purchaseGrandTotal
        purchaseMargin
        purchaseMarginPercentage
        grandBudgetWithMarginTotal
        noMarginTotalPercentage
        subTotalBudgetWithMargin
        subTotalBudgetWithoutMargin
        subTotalBudgetWithMarginPercentage
      }
      quoteTotalDiscount {
        totalAfterDiscount
        totalDiscount
        budgetTotalDiscountOnMargin
        budgetTotalDiscountOnMarginPercentage
        budgetTotalDiscountPercentage
        provisionalTotalDiscountOnMargin
        provisionalTotalDiscountOnMarginPercentage
        provisionalTotalDiscountPercentage
        actualTotalDiscountOnMargin
        actualTotalDiscountOnMarginPercentage
        actualTotalDiscountPercentage
        purchaseTotalDiscountOnMargin
        purchaseTotalDiscountOnMarginPercentage
        purchaseTotalDiscountPercentage
      }
      discount {
        totalDiscount
        totalAfterDiscount
        totalDiscountOnMargin
        totalDiscountOnMarginPercentage
        totalDiscountPercentage
      }
      quoteNumber
      quoteAccountingCategory
      deliveryDate
      quoteTertiaryCategory
      exeLocation
      advertiserJobID
      brand
      jobName
      agencyJobID
      product
      advertiser
      productionJobID
      advertiserAddress
      productionCompany
      productionContact
      vfxCo
      vfxProducer
      editorialCo
      editorialProducer
      musicCo
      musicProducer
      agencyProducer
      agencyCreativeTeam
      prepDays
      buildAndStrikeDays
      preLight
      stageDays
      locationDays
      description
      service
      scope
      vhr
      billingAddress
      dateOfShoot
      photographer
      jobNumber
      photoLocation
      quoteProdValue1
      quoteProdValue2
      quoteProdValue3
      quoteProdValue4
      quoteProdValue5
      quoteProdValue6
      quoteProdValue7
      quoteProdValue8
      quoteProdValue9
      quoteProdValue10
      quoteProdValue11
      quoteProdValue12
      quoteProdValue13
      quoteProdValue14
      quoteProdValue15
      quoteProdValue16
      quoteProdValue17
      quoteProdValue18
      quoteProdValue19
      quoteProdValue20
      quoteProdValue21
      quoteProdValue22
      quoteProdValue23
      quoteProdValue24
      quoteProdValue25
      termsType
      termsSelection
      quoteCurrency
      exeQuoteCurrency
      marginCustomization
      pdfColumnCustomization
      pdfMiscCustomization
      summaryTableCustomization
      quoteHeaderLabel1
      quoteHeaderValue1
      quoteHeaderLabel2
      quoteHeaderValue2
      quoteHeaderLabel3
      quoteHeaderValue3
      quoteHeaderLabel4
      quoteHeaderValue4
      quoteHeaderLabel5
      quoteHeaderValue5
      quoteHeaderLabel6
      quoteHeaderValue6
      quoteHeaderLabel7
      quoteHeaderValue7
      quoteHeaderLabel8
      quoteHeaderValue8
      quoteHeaderLabel9
      quoteHeaderValue9
      quoteHeaderLabel10
      quoteHeaderValue10
      quoteHeaderLabel11
      quoteHeaderValue11
      productionNoteLabels
      budgetSections
      showCo2InSummary
      showCo2InPdf
      numberOfPrepDaysCo2
      numberOfShootDaysCo2
      numberOfPeopleOnSetCo2
      enableTravelCo2
      travelTypeCo2
      percentageOfCrewTravelCo2
      travelTypeLocation2Co2
      percentageOfCrewTravelLocation2Co2
      overtimeHours1Rate
      overtimeHours2Rate
      overtimeHours3Rate
      overtimeHours4Rate
      assignedTenantId
      assignedTenantName
      isExpired
      filledCostlineDetails {
        totalBudget
        totalCrewBudget
        totalPostProdBudget
        crewPrepNumberOfDays
        crewShootNumberOfDays
      }
      proposals {
        items {
          id
          tenantId
          activeFlag
          quoteId
          quoteType
          clientId
          contactId
          status
          noofInvoices
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          createdOn
          updatedOn
          poDate
          poName
          poAmount
          poCurrency
          poNotes
          poVersion
          prevStatus
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          _deleted
          _version
          _lastChangedAt
        }
        nextToken
      }
      createdOn
      updatedOn
      _deleted
      _version
      _lastChangedAt
    }
    invoices {
      items {
        id
        tenantId
        proposalId
        quoteType
        activeFlag
        originalInvoiceId
        creditInvoiceGenerated
        archivedDate
        paidDate
        paymentStatus
        quoteName
        quoteNumber
        projectName
        projectNumber
        clientId
        contactId
        clientName
        contactName
        clientTaxType
        clientEmail
        clientAddress
        clientCountry
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        title
        invoiceNumber
        poNumber
        invoiceAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        clientNote
        isDetailed
        isClientTaxRate
        bankProfileNumber
        invoicesBankProfileName
        invoicesBank
        invoicesIban
        invoicesBic
        invoicesAccountName
        invoiceDate
        invoiceDueDate
        description
        creditComments
        invoiceType
        proposalsDraft {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
          salesAccNumberType
        }
        taxDetails {
          taxRate
          taxPercentage
          taxAmount
          taxableAmount
        }
        salesAccNumberType
        sectionDetails {
          type
          amount
        }
        sectionDetailsByQuote {
          type
          amount
        }
        sectionDetailsByAccSection {
          type
          amount
        }
        proposals {
          id
          tenantId
          activeFlag
          quoteId
          quoteType
          clientId
          contactId
          status
          noofInvoices
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          createdOn
          updatedOn
          poDate
          poName
          poAmount
          poCurrency
          poNotes
          poVersion
          prevStatus
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          _deleted
          _version
          _lastChangedAt
        }
        createdOn
        updatedOn
        uniqueTransactionId
        assignedTenantId
        assignedTenantName
        showBidLetter
        companyLogo
        lastExportedDate
        emailSent
        draftEmailData {
          toEmail
          toCC
          toBCC
          subject
          body
          template
        }
        emailHistory {
          date
          subject
        }
        billitInboxItemId
        billitPeppolStatus
        billitPeppolError
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    createdOn
    updatedOn
    poDate
    poName
    poAmount
    poCurrency
    poNotes
    poDocuments {
      bucket
      region
      key
      identityId
    }
    poVersion
    prevStatus
    assignedTenantId
    assignedTenantName
    showBidLetter
    companyLogo
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnCreateProposalsSubscriptionVariables,
		APITypes.OnCreateProposalsSubscription
	>
export const onUpdateProposals =
	/* GraphQL */ `subscription OnUpdateProposals($filter: ModelSubscriptionProposalsFilterInput) {
  onUpdateProposals(filter: $filter) {
    id
    tenantId
    activeFlag
    quoteId
    quoteType
    clientId
    contactId
    status
    noofInvoices
    quoteName
    quoteNumber
    projectName
    projectNumber
    clientTaxType
    clientName
    contactName
    clientEmail
    clientAddress
    clientCountry
    clientIdNumber
    clientVatNumber
    clientCurrency
    clientTaxRate
    paymentTerms
    total
    clientNote
    isDetailed
    isClientTaxRate
    bankProfileNumber
    proposalsBankProfileName
    proposalsBank
    proposalsIban
    proposalsBic
    proposalsAccountName
    drafts {
      generated
      poNumber
      proposalAmountPercentage
      amount
      amountAfterTax
      taxAmount
      balancePercentage
      balanceAmount
      invoiceId
      invoiceDate
      invoiceDueDate
      description
      readyStatus
      taxDetails {
        taxRate
        taxPercentage
        taxAmount
        taxableAmount
      }
      salesAccNumberType
      sectionDetails {
        type
        amount
      }
      sectionDetailsByQuote {
        type
        amount
      }
      sectionDetailsByAccSection {
        type
        amount
      }
    }
    quote {
      id
      name
      tenantId
      quoteType
      quoteVersion
      aiGenerationRunId
      aiGenerationStatus
      aiGenerationError
      aiGenerationStartedAt
      aiGenerationCompletedAt
      aiGeneratedByUserId
      blankQuoteType
      parentTeamId
      parentSubTeamId
      visibility
      quoteLanguage
      childFreelancers
      offlineIds
      activeFlag
      type
      mergedQuotes
      parentProjectId
      billLocation
      marginLabel
      overheadLabel
      marginAndOverheadLabel
      marginPercentage
      overheadPercentage
      exchangeRate
      localExchangeRate
      localOtNumberOfHours
      exeOtNumberOfHours
      marginVAT_rate
      marginAcc_section
      allowInternational
      freelancers
      parentCompanyId
      companyLogo
      maximizeMinimize
      provisionalColumn
      selectContactById
      clientId
      contactId
      clientName
      projectName
      agency
      agencyRepresentative
      director
      executiveProducer
      lineProducer
      numberOfShootingDays
      notes
      introduction
      shooting
      prep
      shootingCountry
      prelight
      casting
      crew
      buyouts
      locations
      studio
      artDepartment
      wardrobe
      equipment
      travel
      accommodation
      editing
      imagePostproduction
      soundPostproduction
      deliverables
      insurance
      quoteGuidelines
      excluded
      paymentTerms
      miscellaneous
      conclusion
      installment1Percentage
      installment1Date
      installment2Percentage
      installment2Date
      balancePercentage
      balanceDate
      isStarred
      isChecked
      isFinalized
      recapInfoComments
      contact
      quoteTotal {
        budgetSubTotal
        budgetGrandTotal
        budgetMargin
        budgetMarginPercentage
        budgetSeperateMargin
        budgetSeperateMarginPercentage
        budgetSeperateOverhead
        budgetSeperateOverheadPercentage
        provisionalSubTotal
        provisionalGrandTotal
        provisionalMargin
        provisionalMarginPercentage
        actualSubTotal
        actualGrandTotal
        actualMargin
        actualMarginPercentage
        purchaseSubTotal
        purchaseGrandTotal
        purchaseMargin
        purchaseMarginPercentage
        grandBudgetWithMarginTotal
        noMarginTotalPercentage
        subTotalBudgetWithMargin
        subTotalBudgetWithoutMargin
        subTotalBudgetWithMarginPercentage
      }
      quoteTotalDiscount {
        totalAfterDiscount
        totalDiscount
        budgetTotalDiscountOnMargin
        budgetTotalDiscountOnMarginPercentage
        budgetTotalDiscountPercentage
        provisionalTotalDiscountOnMargin
        provisionalTotalDiscountOnMarginPercentage
        provisionalTotalDiscountPercentage
        actualTotalDiscountOnMargin
        actualTotalDiscountOnMarginPercentage
        actualTotalDiscountPercentage
        purchaseTotalDiscountOnMargin
        purchaseTotalDiscountOnMarginPercentage
        purchaseTotalDiscountPercentage
      }
      discount {
        totalDiscount
        totalAfterDiscount
        totalDiscountOnMargin
        totalDiscountOnMarginPercentage
        totalDiscountPercentage
      }
      quoteNumber
      quoteAccountingCategory
      deliveryDate
      quoteTertiaryCategory
      exeLocation
      advertiserJobID
      brand
      jobName
      agencyJobID
      product
      advertiser
      productionJobID
      advertiserAddress
      productionCompany
      productionContact
      vfxCo
      vfxProducer
      editorialCo
      editorialProducer
      musicCo
      musicProducer
      agencyProducer
      agencyCreativeTeam
      prepDays
      buildAndStrikeDays
      preLight
      stageDays
      locationDays
      description
      service
      scope
      vhr
      billingAddress
      dateOfShoot
      photographer
      jobNumber
      photoLocation
      quoteProdValue1
      quoteProdValue2
      quoteProdValue3
      quoteProdValue4
      quoteProdValue5
      quoteProdValue6
      quoteProdValue7
      quoteProdValue8
      quoteProdValue9
      quoteProdValue10
      quoteProdValue11
      quoteProdValue12
      quoteProdValue13
      quoteProdValue14
      quoteProdValue15
      quoteProdValue16
      quoteProdValue17
      quoteProdValue18
      quoteProdValue19
      quoteProdValue20
      quoteProdValue21
      quoteProdValue22
      quoteProdValue23
      quoteProdValue24
      quoteProdValue25
      termsType
      termsSelection
      quoteCurrency
      exeQuoteCurrency
      marginCustomization
      pdfColumnCustomization
      pdfMiscCustomization
      summaryTableCustomization
      quoteHeaderLabel1
      quoteHeaderValue1
      quoteHeaderLabel2
      quoteHeaderValue2
      quoteHeaderLabel3
      quoteHeaderValue3
      quoteHeaderLabel4
      quoteHeaderValue4
      quoteHeaderLabel5
      quoteHeaderValue5
      quoteHeaderLabel6
      quoteHeaderValue6
      quoteHeaderLabel7
      quoteHeaderValue7
      quoteHeaderLabel8
      quoteHeaderValue8
      quoteHeaderLabel9
      quoteHeaderValue9
      quoteHeaderLabel10
      quoteHeaderValue10
      quoteHeaderLabel11
      quoteHeaderValue11
      productionNoteLabels
      budgetSections
      showCo2InSummary
      showCo2InPdf
      numberOfPrepDaysCo2
      numberOfShootDaysCo2
      numberOfPeopleOnSetCo2
      enableTravelCo2
      travelTypeCo2
      percentageOfCrewTravelCo2
      travelTypeLocation2Co2
      percentageOfCrewTravelLocation2Co2
      overtimeHours1Rate
      overtimeHours2Rate
      overtimeHours3Rate
      overtimeHours4Rate
      assignedTenantId
      assignedTenantName
      isExpired
      filledCostlineDetails {
        totalBudget
        totalCrewBudget
        totalPostProdBudget
        crewPrepNumberOfDays
        crewShootNumberOfDays
      }
      proposals {
        items {
          id
          tenantId
          activeFlag
          quoteId
          quoteType
          clientId
          contactId
          status
          noofInvoices
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          createdOn
          updatedOn
          poDate
          poName
          poAmount
          poCurrency
          poNotes
          poVersion
          prevStatus
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          _deleted
          _version
          _lastChangedAt
        }
        nextToken
      }
      createdOn
      updatedOn
      _deleted
      _version
      _lastChangedAt
    }
    invoices {
      items {
        id
        tenantId
        proposalId
        quoteType
        activeFlag
        originalInvoiceId
        creditInvoiceGenerated
        archivedDate
        paidDate
        paymentStatus
        quoteName
        quoteNumber
        projectName
        projectNumber
        clientId
        contactId
        clientName
        contactName
        clientTaxType
        clientEmail
        clientAddress
        clientCountry
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        title
        invoiceNumber
        poNumber
        invoiceAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        clientNote
        isDetailed
        isClientTaxRate
        bankProfileNumber
        invoicesBankProfileName
        invoicesBank
        invoicesIban
        invoicesBic
        invoicesAccountName
        invoiceDate
        invoiceDueDate
        description
        creditComments
        invoiceType
        proposalsDraft {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
          salesAccNumberType
        }
        taxDetails {
          taxRate
          taxPercentage
          taxAmount
          taxableAmount
        }
        salesAccNumberType
        sectionDetails {
          type
          amount
        }
        sectionDetailsByQuote {
          type
          amount
        }
        sectionDetailsByAccSection {
          type
          amount
        }
        proposals {
          id
          tenantId
          activeFlag
          quoteId
          quoteType
          clientId
          contactId
          status
          noofInvoices
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          createdOn
          updatedOn
          poDate
          poName
          poAmount
          poCurrency
          poNotes
          poVersion
          prevStatus
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          _deleted
          _version
          _lastChangedAt
        }
        createdOn
        updatedOn
        uniqueTransactionId
        assignedTenantId
        assignedTenantName
        showBidLetter
        companyLogo
        lastExportedDate
        emailSent
        draftEmailData {
          toEmail
          toCC
          toBCC
          subject
          body
          template
        }
        emailHistory {
          date
          subject
        }
        billitInboxItemId
        billitPeppolStatus
        billitPeppolError
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    createdOn
    updatedOn
    poDate
    poName
    poAmount
    poCurrency
    poNotes
    poDocuments {
      bucket
      region
      key
      identityId
    }
    poVersion
    prevStatus
    assignedTenantId
    assignedTenantName
    showBidLetter
    companyLogo
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnUpdateProposalsSubscriptionVariables,
		APITypes.OnUpdateProposalsSubscription
	>
export const onDeleteProposals =
	/* GraphQL */ `subscription OnDeleteProposals($filter: ModelSubscriptionProposalsFilterInput) {
  onDeleteProposals(filter: $filter) {
    id
    tenantId
    activeFlag
    quoteId
    quoteType
    clientId
    contactId
    status
    noofInvoices
    quoteName
    quoteNumber
    projectName
    projectNumber
    clientTaxType
    clientName
    contactName
    clientEmail
    clientAddress
    clientCountry
    clientIdNumber
    clientVatNumber
    clientCurrency
    clientTaxRate
    paymentTerms
    total
    clientNote
    isDetailed
    isClientTaxRate
    bankProfileNumber
    proposalsBankProfileName
    proposalsBank
    proposalsIban
    proposalsBic
    proposalsAccountName
    drafts {
      generated
      poNumber
      proposalAmountPercentage
      amount
      amountAfterTax
      taxAmount
      balancePercentage
      balanceAmount
      invoiceId
      invoiceDate
      invoiceDueDate
      description
      readyStatus
      taxDetails {
        taxRate
        taxPercentage
        taxAmount
        taxableAmount
      }
      salesAccNumberType
      sectionDetails {
        type
        amount
      }
      sectionDetailsByQuote {
        type
        amount
      }
      sectionDetailsByAccSection {
        type
        amount
      }
    }
    quote {
      id
      name
      tenantId
      quoteType
      quoteVersion
      aiGenerationRunId
      aiGenerationStatus
      aiGenerationError
      aiGenerationStartedAt
      aiGenerationCompletedAt
      aiGeneratedByUserId
      blankQuoteType
      parentTeamId
      parentSubTeamId
      visibility
      quoteLanguage
      childFreelancers
      offlineIds
      activeFlag
      type
      mergedQuotes
      parentProjectId
      billLocation
      marginLabel
      overheadLabel
      marginAndOverheadLabel
      marginPercentage
      overheadPercentage
      exchangeRate
      localExchangeRate
      localOtNumberOfHours
      exeOtNumberOfHours
      marginVAT_rate
      marginAcc_section
      allowInternational
      freelancers
      parentCompanyId
      companyLogo
      maximizeMinimize
      provisionalColumn
      selectContactById
      clientId
      contactId
      clientName
      projectName
      agency
      agencyRepresentative
      director
      executiveProducer
      lineProducer
      numberOfShootingDays
      notes
      introduction
      shooting
      prep
      shootingCountry
      prelight
      casting
      crew
      buyouts
      locations
      studio
      artDepartment
      wardrobe
      equipment
      travel
      accommodation
      editing
      imagePostproduction
      soundPostproduction
      deliverables
      insurance
      quoteGuidelines
      excluded
      paymentTerms
      miscellaneous
      conclusion
      installment1Percentage
      installment1Date
      installment2Percentage
      installment2Date
      balancePercentage
      balanceDate
      isStarred
      isChecked
      isFinalized
      recapInfoComments
      contact
      quoteTotal {
        budgetSubTotal
        budgetGrandTotal
        budgetMargin
        budgetMarginPercentage
        budgetSeperateMargin
        budgetSeperateMarginPercentage
        budgetSeperateOverhead
        budgetSeperateOverheadPercentage
        provisionalSubTotal
        provisionalGrandTotal
        provisionalMargin
        provisionalMarginPercentage
        actualSubTotal
        actualGrandTotal
        actualMargin
        actualMarginPercentage
        purchaseSubTotal
        purchaseGrandTotal
        purchaseMargin
        purchaseMarginPercentage
        grandBudgetWithMarginTotal
        noMarginTotalPercentage
        subTotalBudgetWithMargin
        subTotalBudgetWithoutMargin
        subTotalBudgetWithMarginPercentage
      }
      quoteTotalDiscount {
        totalAfterDiscount
        totalDiscount
        budgetTotalDiscountOnMargin
        budgetTotalDiscountOnMarginPercentage
        budgetTotalDiscountPercentage
        provisionalTotalDiscountOnMargin
        provisionalTotalDiscountOnMarginPercentage
        provisionalTotalDiscountPercentage
        actualTotalDiscountOnMargin
        actualTotalDiscountOnMarginPercentage
        actualTotalDiscountPercentage
        purchaseTotalDiscountOnMargin
        purchaseTotalDiscountOnMarginPercentage
        purchaseTotalDiscountPercentage
      }
      discount {
        totalDiscount
        totalAfterDiscount
        totalDiscountOnMargin
        totalDiscountOnMarginPercentage
        totalDiscountPercentage
      }
      quoteNumber
      quoteAccountingCategory
      deliveryDate
      quoteTertiaryCategory
      exeLocation
      advertiserJobID
      brand
      jobName
      agencyJobID
      product
      advertiser
      productionJobID
      advertiserAddress
      productionCompany
      productionContact
      vfxCo
      vfxProducer
      editorialCo
      editorialProducer
      musicCo
      musicProducer
      agencyProducer
      agencyCreativeTeam
      prepDays
      buildAndStrikeDays
      preLight
      stageDays
      locationDays
      description
      service
      scope
      vhr
      billingAddress
      dateOfShoot
      photographer
      jobNumber
      photoLocation
      quoteProdValue1
      quoteProdValue2
      quoteProdValue3
      quoteProdValue4
      quoteProdValue5
      quoteProdValue6
      quoteProdValue7
      quoteProdValue8
      quoteProdValue9
      quoteProdValue10
      quoteProdValue11
      quoteProdValue12
      quoteProdValue13
      quoteProdValue14
      quoteProdValue15
      quoteProdValue16
      quoteProdValue17
      quoteProdValue18
      quoteProdValue19
      quoteProdValue20
      quoteProdValue21
      quoteProdValue22
      quoteProdValue23
      quoteProdValue24
      quoteProdValue25
      termsType
      termsSelection
      quoteCurrency
      exeQuoteCurrency
      marginCustomization
      pdfColumnCustomization
      pdfMiscCustomization
      summaryTableCustomization
      quoteHeaderLabel1
      quoteHeaderValue1
      quoteHeaderLabel2
      quoteHeaderValue2
      quoteHeaderLabel3
      quoteHeaderValue3
      quoteHeaderLabel4
      quoteHeaderValue4
      quoteHeaderLabel5
      quoteHeaderValue5
      quoteHeaderLabel6
      quoteHeaderValue6
      quoteHeaderLabel7
      quoteHeaderValue7
      quoteHeaderLabel8
      quoteHeaderValue8
      quoteHeaderLabel9
      quoteHeaderValue9
      quoteHeaderLabel10
      quoteHeaderValue10
      quoteHeaderLabel11
      quoteHeaderValue11
      productionNoteLabels
      budgetSections
      showCo2InSummary
      showCo2InPdf
      numberOfPrepDaysCo2
      numberOfShootDaysCo2
      numberOfPeopleOnSetCo2
      enableTravelCo2
      travelTypeCo2
      percentageOfCrewTravelCo2
      travelTypeLocation2Co2
      percentageOfCrewTravelLocation2Co2
      overtimeHours1Rate
      overtimeHours2Rate
      overtimeHours3Rate
      overtimeHours4Rate
      assignedTenantId
      assignedTenantName
      isExpired
      filledCostlineDetails {
        totalBudget
        totalCrewBudget
        totalPostProdBudget
        crewPrepNumberOfDays
        crewShootNumberOfDays
      }
      proposals {
        items {
          id
          tenantId
          activeFlag
          quoteId
          quoteType
          clientId
          contactId
          status
          noofInvoices
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          createdOn
          updatedOn
          poDate
          poName
          poAmount
          poCurrency
          poNotes
          poVersion
          prevStatus
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          _deleted
          _version
          _lastChangedAt
        }
        nextToken
      }
      createdOn
      updatedOn
      _deleted
      _version
      _lastChangedAt
    }
    invoices {
      items {
        id
        tenantId
        proposalId
        quoteType
        activeFlag
        originalInvoiceId
        creditInvoiceGenerated
        archivedDate
        paidDate
        paymentStatus
        quoteName
        quoteNumber
        projectName
        projectNumber
        clientId
        contactId
        clientName
        contactName
        clientTaxType
        clientEmail
        clientAddress
        clientCountry
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        title
        invoiceNumber
        poNumber
        invoiceAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        clientNote
        isDetailed
        isClientTaxRate
        bankProfileNumber
        invoicesBankProfileName
        invoicesBank
        invoicesIban
        invoicesBic
        invoicesAccountName
        invoiceDate
        invoiceDueDate
        description
        creditComments
        invoiceType
        proposalsDraft {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
          salesAccNumberType
        }
        taxDetails {
          taxRate
          taxPercentage
          taxAmount
          taxableAmount
        }
        salesAccNumberType
        sectionDetails {
          type
          amount
        }
        sectionDetailsByQuote {
          type
          amount
        }
        sectionDetailsByAccSection {
          type
          amount
        }
        proposals {
          id
          tenantId
          activeFlag
          quoteId
          quoteType
          clientId
          contactId
          status
          noofInvoices
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          createdOn
          updatedOn
          poDate
          poName
          poAmount
          poCurrency
          poNotes
          poVersion
          prevStatus
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          _deleted
          _version
          _lastChangedAt
        }
        createdOn
        updatedOn
        uniqueTransactionId
        assignedTenantId
        assignedTenantName
        showBidLetter
        companyLogo
        lastExportedDate
        emailSent
        draftEmailData {
          toEmail
          toCC
          toBCC
          subject
          body
          template
        }
        emailHistory {
          date
          subject
        }
        billitInboxItemId
        billitPeppolStatus
        billitPeppolError
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    createdOn
    updatedOn
    poDate
    poName
    poAmount
    poCurrency
    poNotes
    poDocuments {
      bucket
      region
      key
      identityId
    }
    poVersion
    prevStatus
    assignedTenantId
    assignedTenantName
    showBidLetter
    companyLogo
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnDeleteProposalsSubscriptionVariables,
		APITypes.OnDeleteProposalsSubscription
	>
export const onCreatePurchase =
	/* GraphQL */ `subscription OnCreatePurchase($filter: ModelSubscriptionPurchaseFilterInput) {
  onCreatePurchase(filter: $filter) {
    id
    tenantId
    activeFlag
    quoteId
    supplierId
    recapCostlineId
    quoteName
    projectName
    supplierName
    recapCostlineItem
    recapCostlineItem_fr
    currency
    provisionalTotal
    invoiceTotal
    taxAmount
    purchaseInvoiceDueDate
    purchaseArchivedDate
    purchasePaidDate
    supplierCreditorAccount
    purchaseOrderId
    poAvailable
    invoiceAvailable
    paymentStatus
    purchaseType
    supplierType
    invoiceKey
    tags
    invoiceDocuments {
      bucket
      region
      key
      identityId
    }
    quoteNumber
    projectNumber
    invoiceNumber
    purchaseToPayDate
    purchaseNumber
    purchaseOrderNumber
    projectId
    supplierTerms
    quantity
    number
    rate
    taxRate
    deliveryDate
    deliveryAddress
    poComments
    poGenerated
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnCreatePurchaseSubscriptionVariables,
		APITypes.OnCreatePurchaseSubscription
	>
export const onUpdatePurchase =
	/* GraphQL */ `subscription OnUpdatePurchase($filter: ModelSubscriptionPurchaseFilterInput) {
  onUpdatePurchase(filter: $filter) {
    id
    tenantId
    activeFlag
    quoteId
    supplierId
    recapCostlineId
    quoteName
    projectName
    supplierName
    recapCostlineItem
    recapCostlineItem_fr
    currency
    provisionalTotal
    invoiceTotal
    taxAmount
    purchaseInvoiceDueDate
    purchaseArchivedDate
    purchasePaidDate
    supplierCreditorAccount
    purchaseOrderId
    poAvailable
    invoiceAvailable
    paymentStatus
    purchaseType
    supplierType
    invoiceKey
    tags
    invoiceDocuments {
      bucket
      region
      key
      identityId
    }
    quoteNumber
    projectNumber
    invoiceNumber
    purchaseToPayDate
    purchaseNumber
    purchaseOrderNumber
    projectId
    supplierTerms
    quantity
    number
    rate
    taxRate
    deliveryDate
    deliveryAddress
    poComments
    poGenerated
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnUpdatePurchaseSubscriptionVariables,
		APITypes.OnUpdatePurchaseSubscription
	>
export const onDeletePurchase =
	/* GraphQL */ `subscription OnDeletePurchase($filter: ModelSubscriptionPurchaseFilterInput) {
  onDeletePurchase(filter: $filter) {
    id
    tenantId
    activeFlag
    quoteId
    supplierId
    recapCostlineId
    quoteName
    projectName
    supplierName
    recapCostlineItem
    recapCostlineItem_fr
    currency
    provisionalTotal
    invoiceTotal
    taxAmount
    purchaseInvoiceDueDate
    purchaseArchivedDate
    purchasePaidDate
    supplierCreditorAccount
    purchaseOrderId
    poAvailable
    invoiceAvailable
    paymentStatus
    purchaseType
    supplierType
    invoiceKey
    tags
    invoiceDocuments {
      bucket
      region
      key
      identityId
    }
    quoteNumber
    projectNumber
    invoiceNumber
    purchaseToPayDate
    purchaseNumber
    purchaseOrderNumber
    projectId
    supplierTerms
    quantity
    number
    rate
    taxRate
    deliveryDate
    deliveryAddress
    poComments
    poGenerated
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnDeletePurchaseSubscriptionVariables,
		APITypes.OnDeletePurchaseSubscription
	>
export const onCreatePurchaseOrder =
	/* GraphQL */ `subscription OnCreatePurchaseOrder(
  $filter: ModelSubscriptionPurchaseOrderFilterInput
) {
  onCreatePurchaseOrder(filter: $filter) {
    id
    tenantId
    activeFlag
    purchaseOrderNumber
    quoteId
    supplierId
    recapCostlineId
    costlineName
    costlineName_fr
    projectId
    quoteNumber
    poAvailable
    supplierName
    supplierTerms
    quantity
    number
    rate
    provisionalTotal
    taxRate
    deliveryDate
    deliveryAddress
    comments
    status
    generated
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedSubscription<
		APITypes.OnCreatePurchaseOrderSubscriptionVariables,
		APITypes.OnCreatePurchaseOrderSubscription
	>
export const onUpdatePurchaseOrder =
	/* GraphQL */ `subscription OnUpdatePurchaseOrder(
  $filter: ModelSubscriptionPurchaseOrderFilterInput
) {
  onUpdatePurchaseOrder(filter: $filter) {
    id
    tenantId
    activeFlag
    purchaseOrderNumber
    quoteId
    supplierId
    recapCostlineId
    costlineName
    costlineName_fr
    projectId
    quoteNumber
    poAvailable
    supplierName
    supplierTerms
    quantity
    number
    rate
    provisionalTotal
    taxRate
    deliveryDate
    deliveryAddress
    comments
    status
    generated
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedSubscription<
		APITypes.OnUpdatePurchaseOrderSubscriptionVariables,
		APITypes.OnUpdatePurchaseOrderSubscription
	>
export const onDeletePurchaseOrder =
	/* GraphQL */ `subscription OnDeletePurchaseOrder(
  $filter: ModelSubscriptionPurchaseOrderFilterInput
) {
  onDeletePurchaseOrder(filter: $filter) {
    id
    tenantId
    activeFlag
    purchaseOrderNumber
    quoteId
    supplierId
    recapCostlineId
    costlineName
    costlineName_fr
    projectId
    quoteNumber
    poAvailable
    supplierName
    supplierTerms
    quantity
    number
    rate
    provisionalTotal
    taxRate
    deliveryDate
    deliveryAddress
    comments
    status
    generated
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedSubscription<
		APITypes.OnDeletePurchaseOrderSubscriptionVariables,
		APITypes.OnDeletePurchaseOrderSubscription
	>
export const onCreateQuote =
	/* GraphQL */ `subscription OnCreateQuote($filter: ModelSubscriptionQuoteFilterInput) {
  onCreateQuote(filter: $filter) {
    id
    name
    tenantId
    quoteType
    quoteVersion
    aiGenerationRunId
    aiGenerationStatus
    aiGenerationError
    aiGenerationStartedAt
    aiGenerationCompletedAt
    aiGeneratedByUserId
    blankQuoteType
    parentTeamId
    parentSubTeamId
    visibility
    quoteLanguage
    childFreelancers
    offlineIds
    activeFlag
    type
    mergedQuotes
    parentProjectId
    billLocation
    marginLabel
    overheadLabel
    marginAndOverheadLabel
    marginPercentage
    overheadPercentage
    exchangeRate
    localExchangeRate
    localOtNumberOfHours
    exeOtNumberOfHours
    marginVAT_rate
    marginAcc_section
    allowInternational
    freelancers
    parentCompanyId
    companyLogo
    maximizeMinimize
    provisionalColumn
    selectContactById
    clientId
    contactId
    clientName
    projectName
    agency
    agencyRepresentative
    director
    executiveProducer
    lineProducer
    numberOfShootingDays
    notes
    introduction
    shooting
    prep
    shootingCountry
    prelight
    casting
    crew
    buyouts
    locations
    studio
    artDepartment
    wardrobe
    equipment
    travel
    accommodation
    editing
    imagePostproduction
    soundPostproduction
    deliverables
    insurance
    quoteGuidelines
    excluded
    paymentTerms
    miscellaneous
    conclusion
    installment1Percentage
    installment1Date
    installment2Percentage
    installment2Date
    balancePercentage
    balanceDate
    isStarred
    isChecked
    isFinalized
    recapInfoComments
    contact
    quoteTotal {
      budgetSubTotal
      budgetGrandTotal
      budgetMargin
      budgetMarginPercentage
      budgetSeperateMargin
      budgetSeperateMarginPercentage
      budgetSeperateOverhead
      budgetSeperateOverheadPercentage
      provisionalSubTotal
      provisionalGrandTotal
      provisionalMargin
      provisionalMarginPercentage
      actualSubTotal
      actualGrandTotal
      actualMargin
      actualMarginPercentage
      purchaseSubTotal
      purchaseGrandTotal
      purchaseMargin
      purchaseMarginPercentage
      grandBudgetWithMarginTotal
      noMarginTotalPercentage
      subTotalBudgetWithMargin
      subTotalBudgetWithoutMargin
      subTotalBudgetWithMarginPercentage
    }
    quoteTotalDiscount {
      totalAfterDiscount
      totalDiscount
      budgetTotalDiscountOnMargin
      budgetTotalDiscountOnMarginPercentage
      budgetTotalDiscountPercentage
      provisionalTotalDiscountOnMargin
      provisionalTotalDiscountOnMarginPercentage
      provisionalTotalDiscountPercentage
      actualTotalDiscountOnMargin
      actualTotalDiscountOnMarginPercentage
      actualTotalDiscountPercentage
      purchaseTotalDiscountOnMargin
      purchaseTotalDiscountOnMarginPercentage
      purchaseTotalDiscountPercentage
    }
    discount {
      totalDiscount
      totalAfterDiscount
      totalDiscountOnMargin
      totalDiscountOnMarginPercentage
      totalDiscountPercentage
    }
    quoteNumber
    quoteAccountingCategory
    deliveryDate
    quoteTertiaryCategory
    exeLocation
    advertiserJobID
    brand
    jobName
    agencyJobID
    product
    advertiser
    productionJobID
    advertiserAddress
    productionCompany
    productionContact
    vfxCo
    vfxProducer
    editorialCo
    editorialProducer
    musicCo
    musicProducer
    agencyProducer
    agencyCreativeTeam
    prepDays
    buildAndStrikeDays
    preLight
    stageDays
    locationDays
    description
    service
    scope
    vhr
    billingAddress
    dateOfShoot
    photographer
    jobNumber
    photoLocation
    quoteProdValue1
    quoteProdValue2
    quoteProdValue3
    quoteProdValue4
    quoteProdValue5
    quoteProdValue6
    quoteProdValue7
    quoteProdValue8
    quoteProdValue9
    quoteProdValue10
    quoteProdValue11
    quoteProdValue12
    quoteProdValue13
    quoteProdValue14
    quoteProdValue15
    quoteProdValue16
    quoteProdValue17
    quoteProdValue18
    quoteProdValue19
    quoteProdValue20
    quoteProdValue21
    quoteProdValue22
    quoteProdValue23
    quoteProdValue24
    quoteProdValue25
    termsType
    termsSelection
    quoteCurrency
    exeQuoteCurrency
    marginCustomization
    pdfColumnCustomization
    pdfMiscCustomization
    summaryTableCustomization
    quoteHeaderLabel1
    quoteHeaderValue1
    quoteHeaderLabel2
    quoteHeaderValue2
    quoteHeaderLabel3
    quoteHeaderValue3
    quoteHeaderLabel4
    quoteHeaderValue4
    quoteHeaderLabel5
    quoteHeaderValue5
    quoteHeaderLabel6
    quoteHeaderValue6
    quoteHeaderLabel7
    quoteHeaderValue7
    quoteHeaderLabel8
    quoteHeaderValue8
    quoteHeaderLabel9
    quoteHeaderValue9
    quoteHeaderLabel10
    quoteHeaderValue10
    quoteHeaderLabel11
    quoteHeaderValue11
    productionNoteLabels
    budgetSections
    showCo2InSummary
    showCo2InPdf
    numberOfPrepDaysCo2
    numberOfShootDaysCo2
    numberOfPeopleOnSetCo2
    enableTravelCo2
    travelTypeCo2
    percentageOfCrewTravelCo2
    travelTypeLocation2Co2
    percentageOfCrewTravelLocation2Co2
    overtimeHours1Rate
    overtimeHours2Rate
    overtimeHours3Rate
    overtimeHours4Rate
    assignedTenantId
    assignedTenantName
    isExpired
    filledCostlineDetails {
      totalBudget
      totalCrewBudget
      totalPostProdBudget
      crewPrepNumberOfDays
      crewShootNumberOfDays
    }
    proposals {
      items {
        id
        tenantId
        activeFlag
        quoteId
        quoteType
        clientId
        contactId
        status
        noofInvoices
        quoteName
        quoteNumber
        projectName
        projectNumber
        clientTaxType
        clientName
        contactName
        clientEmail
        clientAddress
        clientCountry
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        paymentTerms
        total
        clientNote
        isDetailed
        isClientTaxRate
        bankProfileNumber
        proposalsBankProfileName
        proposalsBank
        proposalsIban
        proposalsBic
        proposalsAccountName
        drafts {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
          salesAccNumberType
        }
        quote {
          id
          name
          tenantId
          quoteType
          quoteVersion
          aiGenerationRunId
          aiGenerationStatus
          aiGenerationError
          aiGenerationStartedAt
          aiGenerationCompletedAt
          aiGeneratedByUserId
          blankQuoteType
          parentTeamId
          parentSubTeamId
          visibility
          quoteLanguage
          childFreelancers
          offlineIds
          activeFlag
          type
          mergedQuotes
          parentProjectId
          billLocation
          marginLabel
          overheadLabel
          marginAndOverheadLabel
          marginPercentage
          overheadPercentage
          exchangeRate
          localExchangeRate
          localOtNumberOfHours
          exeOtNumberOfHours
          marginVAT_rate
          marginAcc_section
          allowInternational
          freelancers
          parentCompanyId
          companyLogo
          maximizeMinimize
          provisionalColumn
          selectContactById
          clientId
          contactId
          clientName
          projectName
          agency
          agencyRepresentative
          director
          executiveProducer
          lineProducer
          numberOfShootingDays
          notes
          introduction
          shooting
          prep
          shootingCountry
          prelight
          casting
          crew
          buyouts
          locations
          studio
          artDepartment
          wardrobe
          equipment
          travel
          accommodation
          editing
          imagePostproduction
          soundPostproduction
          deliverables
          insurance
          quoteGuidelines
          excluded
          paymentTerms
          miscellaneous
          conclusion
          installment1Percentage
          installment1Date
          installment2Percentage
          installment2Date
          balancePercentage
          balanceDate
          isStarred
          isChecked
          isFinalized
          recapInfoComments
          contact
          quoteNumber
          quoteAccountingCategory
          deliveryDate
          quoteTertiaryCategory
          exeLocation
          advertiserJobID
          brand
          jobName
          agencyJobID
          product
          advertiser
          productionJobID
          advertiserAddress
          productionCompany
          productionContact
          vfxCo
          vfxProducer
          editorialCo
          editorialProducer
          musicCo
          musicProducer
          agencyProducer
          agencyCreativeTeam
          prepDays
          buildAndStrikeDays
          preLight
          stageDays
          locationDays
          description
          service
          scope
          vhr
          billingAddress
          dateOfShoot
          photographer
          jobNumber
          photoLocation
          quoteProdValue1
          quoteProdValue2
          quoteProdValue3
          quoteProdValue4
          quoteProdValue5
          quoteProdValue6
          quoteProdValue7
          quoteProdValue8
          quoteProdValue9
          quoteProdValue10
          quoteProdValue11
          quoteProdValue12
          quoteProdValue13
          quoteProdValue14
          quoteProdValue15
          quoteProdValue16
          quoteProdValue17
          quoteProdValue18
          quoteProdValue19
          quoteProdValue20
          quoteProdValue21
          quoteProdValue22
          quoteProdValue23
          quoteProdValue24
          quoteProdValue25
          termsType
          termsSelection
          quoteCurrency
          exeQuoteCurrency
          marginCustomization
          pdfColumnCustomization
          pdfMiscCustomization
          summaryTableCustomization
          quoteHeaderLabel1
          quoteHeaderValue1
          quoteHeaderLabel2
          quoteHeaderValue2
          quoteHeaderLabel3
          quoteHeaderValue3
          quoteHeaderLabel4
          quoteHeaderValue4
          quoteHeaderLabel5
          quoteHeaderValue5
          quoteHeaderLabel6
          quoteHeaderValue6
          quoteHeaderLabel7
          quoteHeaderValue7
          quoteHeaderLabel8
          quoteHeaderValue8
          quoteHeaderLabel9
          quoteHeaderValue9
          quoteHeaderLabel10
          quoteHeaderValue10
          quoteHeaderLabel11
          quoteHeaderValue11
          productionNoteLabels
          budgetSections
          showCo2InSummary
          showCo2InPdf
          numberOfPrepDaysCo2
          numberOfShootDaysCo2
          numberOfPeopleOnSetCo2
          enableTravelCo2
          travelTypeCo2
          percentageOfCrewTravelCo2
          travelTypeLocation2Co2
          percentageOfCrewTravelLocation2Co2
          overtimeHours1Rate
          overtimeHours2Rate
          overtimeHours3Rate
          overtimeHours4Rate
          assignedTenantId
          assignedTenantName
          isExpired
          createdOn
          updatedOn
          _deleted
          _version
          _lastChangedAt
        }
        invoices {
          nextToken
        }
        createdOn
        updatedOn
        poDate
        poName
        poAmount
        poCurrency
        poNotes
        poDocuments {
          bucket
          region
          key
          identityId
        }
        poVersion
        prevStatus
        assignedTenantId
        assignedTenantName
        showBidLetter
        companyLogo
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnCreateQuoteSubscriptionVariables,
		APITypes.OnCreateQuoteSubscription
	>
export const onUpdateQuote =
	/* GraphQL */ `subscription OnUpdateQuote($filter: ModelSubscriptionQuoteFilterInput) {
  onUpdateQuote(filter: $filter) {
    id
    name
    tenantId
    quoteType
    quoteVersion
    aiGenerationRunId
    aiGenerationStatus
    aiGenerationError
    aiGenerationStartedAt
    aiGenerationCompletedAt
    aiGeneratedByUserId
    blankQuoteType
    parentTeamId
    parentSubTeamId
    visibility
    quoteLanguage
    childFreelancers
    offlineIds
    activeFlag
    type
    mergedQuotes
    parentProjectId
    billLocation
    marginLabel
    overheadLabel
    marginAndOverheadLabel
    marginPercentage
    overheadPercentage
    exchangeRate
    localExchangeRate
    localOtNumberOfHours
    exeOtNumberOfHours
    marginVAT_rate
    marginAcc_section
    allowInternational
    freelancers
    parentCompanyId
    companyLogo
    maximizeMinimize
    provisionalColumn
    selectContactById
    clientId
    contactId
    clientName
    projectName
    agency
    agencyRepresentative
    director
    executiveProducer
    lineProducer
    numberOfShootingDays
    notes
    introduction
    shooting
    prep
    shootingCountry
    prelight
    casting
    crew
    buyouts
    locations
    studio
    artDepartment
    wardrobe
    equipment
    travel
    accommodation
    editing
    imagePostproduction
    soundPostproduction
    deliverables
    insurance
    quoteGuidelines
    excluded
    paymentTerms
    miscellaneous
    conclusion
    installment1Percentage
    installment1Date
    installment2Percentage
    installment2Date
    balancePercentage
    balanceDate
    isStarred
    isChecked
    isFinalized
    recapInfoComments
    contact
    quoteTotal {
      budgetSubTotal
      budgetGrandTotal
      budgetMargin
      budgetMarginPercentage
      budgetSeperateMargin
      budgetSeperateMarginPercentage
      budgetSeperateOverhead
      budgetSeperateOverheadPercentage
      provisionalSubTotal
      provisionalGrandTotal
      provisionalMargin
      provisionalMarginPercentage
      actualSubTotal
      actualGrandTotal
      actualMargin
      actualMarginPercentage
      purchaseSubTotal
      purchaseGrandTotal
      purchaseMargin
      purchaseMarginPercentage
      grandBudgetWithMarginTotal
      noMarginTotalPercentage
      subTotalBudgetWithMargin
      subTotalBudgetWithoutMargin
      subTotalBudgetWithMarginPercentage
    }
    quoteTotalDiscount {
      totalAfterDiscount
      totalDiscount
      budgetTotalDiscountOnMargin
      budgetTotalDiscountOnMarginPercentage
      budgetTotalDiscountPercentage
      provisionalTotalDiscountOnMargin
      provisionalTotalDiscountOnMarginPercentage
      provisionalTotalDiscountPercentage
      actualTotalDiscountOnMargin
      actualTotalDiscountOnMarginPercentage
      actualTotalDiscountPercentage
      purchaseTotalDiscountOnMargin
      purchaseTotalDiscountOnMarginPercentage
      purchaseTotalDiscountPercentage
    }
    discount {
      totalDiscount
      totalAfterDiscount
      totalDiscountOnMargin
      totalDiscountOnMarginPercentage
      totalDiscountPercentage
    }
    quoteNumber
    quoteAccountingCategory
    deliveryDate
    quoteTertiaryCategory
    exeLocation
    advertiserJobID
    brand
    jobName
    agencyJobID
    product
    advertiser
    productionJobID
    advertiserAddress
    productionCompany
    productionContact
    vfxCo
    vfxProducer
    editorialCo
    editorialProducer
    musicCo
    musicProducer
    agencyProducer
    agencyCreativeTeam
    prepDays
    buildAndStrikeDays
    preLight
    stageDays
    locationDays
    description
    service
    scope
    vhr
    billingAddress
    dateOfShoot
    photographer
    jobNumber
    photoLocation
    quoteProdValue1
    quoteProdValue2
    quoteProdValue3
    quoteProdValue4
    quoteProdValue5
    quoteProdValue6
    quoteProdValue7
    quoteProdValue8
    quoteProdValue9
    quoteProdValue10
    quoteProdValue11
    quoteProdValue12
    quoteProdValue13
    quoteProdValue14
    quoteProdValue15
    quoteProdValue16
    quoteProdValue17
    quoteProdValue18
    quoteProdValue19
    quoteProdValue20
    quoteProdValue21
    quoteProdValue22
    quoteProdValue23
    quoteProdValue24
    quoteProdValue25
    termsType
    termsSelection
    quoteCurrency
    exeQuoteCurrency
    marginCustomization
    pdfColumnCustomization
    pdfMiscCustomization
    summaryTableCustomization
    quoteHeaderLabel1
    quoteHeaderValue1
    quoteHeaderLabel2
    quoteHeaderValue2
    quoteHeaderLabel3
    quoteHeaderValue3
    quoteHeaderLabel4
    quoteHeaderValue4
    quoteHeaderLabel5
    quoteHeaderValue5
    quoteHeaderLabel6
    quoteHeaderValue6
    quoteHeaderLabel7
    quoteHeaderValue7
    quoteHeaderLabel8
    quoteHeaderValue8
    quoteHeaderLabel9
    quoteHeaderValue9
    quoteHeaderLabel10
    quoteHeaderValue10
    quoteHeaderLabel11
    quoteHeaderValue11
    productionNoteLabels
    budgetSections
    showCo2InSummary
    showCo2InPdf
    numberOfPrepDaysCo2
    numberOfShootDaysCo2
    numberOfPeopleOnSetCo2
    enableTravelCo2
    travelTypeCo2
    percentageOfCrewTravelCo2
    travelTypeLocation2Co2
    percentageOfCrewTravelLocation2Co2
    overtimeHours1Rate
    overtimeHours2Rate
    overtimeHours3Rate
    overtimeHours4Rate
    assignedTenantId
    assignedTenantName
    isExpired
    filledCostlineDetails {
      totalBudget
      totalCrewBudget
      totalPostProdBudget
      crewPrepNumberOfDays
      crewShootNumberOfDays
    }
    proposals {
      items {
        id
        tenantId
        activeFlag
        quoteId
        quoteType
        clientId
        contactId
        status
        noofInvoices
        quoteName
        quoteNumber
        projectName
        projectNumber
        clientTaxType
        clientName
        contactName
        clientEmail
        clientAddress
        clientCountry
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        paymentTerms
        total
        clientNote
        isDetailed
        isClientTaxRate
        bankProfileNumber
        proposalsBankProfileName
        proposalsBank
        proposalsIban
        proposalsBic
        proposalsAccountName
        drafts {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
          salesAccNumberType
        }
        quote {
          id
          name
          tenantId
          quoteType
          quoteVersion
          aiGenerationRunId
          aiGenerationStatus
          aiGenerationError
          aiGenerationStartedAt
          aiGenerationCompletedAt
          aiGeneratedByUserId
          blankQuoteType
          parentTeamId
          parentSubTeamId
          visibility
          quoteLanguage
          childFreelancers
          offlineIds
          activeFlag
          type
          mergedQuotes
          parentProjectId
          billLocation
          marginLabel
          overheadLabel
          marginAndOverheadLabel
          marginPercentage
          overheadPercentage
          exchangeRate
          localExchangeRate
          localOtNumberOfHours
          exeOtNumberOfHours
          marginVAT_rate
          marginAcc_section
          allowInternational
          freelancers
          parentCompanyId
          companyLogo
          maximizeMinimize
          provisionalColumn
          selectContactById
          clientId
          contactId
          clientName
          projectName
          agency
          agencyRepresentative
          director
          executiveProducer
          lineProducer
          numberOfShootingDays
          notes
          introduction
          shooting
          prep
          shootingCountry
          prelight
          casting
          crew
          buyouts
          locations
          studio
          artDepartment
          wardrobe
          equipment
          travel
          accommodation
          editing
          imagePostproduction
          soundPostproduction
          deliverables
          insurance
          quoteGuidelines
          excluded
          paymentTerms
          miscellaneous
          conclusion
          installment1Percentage
          installment1Date
          installment2Percentage
          installment2Date
          balancePercentage
          balanceDate
          isStarred
          isChecked
          isFinalized
          recapInfoComments
          contact
          quoteNumber
          quoteAccountingCategory
          deliveryDate
          quoteTertiaryCategory
          exeLocation
          advertiserJobID
          brand
          jobName
          agencyJobID
          product
          advertiser
          productionJobID
          advertiserAddress
          productionCompany
          productionContact
          vfxCo
          vfxProducer
          editorialCo
          editorialProducer
          musicCo
          musicProducer
          agencyProducer
          agencyCreativeTeam
          prepDays
          buildAndStrikeDays
          preLight
          stageDays
          locationDays
          description
          service
          scope
          vhr
          billingAddress
          dateOfShoot
          photographer
          jobNumber
          photoLocation
          quoteProdValue1
          quoteProdValue2
          quoteProdValue3
          quoteProdValue4
          quoteProdValue5
          quoteProdValue6
          quoteProdValue7
          quoteProdValue8
          quoteProdValue9
          quoteProdValue10
          quoteProdValue11
          quoteProdValue12
          quoteProdValue13
          quoteProdValue14
          quoteProdValue15
          quoteProdValue16
          quoteProdValue17
          quoteProdValue18
          quoteProdValue19
          quoteProdValue20
          quoteProdValue21
          quoteProdValue22
          quoteProdValue23
          quoteProdValue24
          quoteProdValue25
          termsType
          termsSelection
          quoteCurrency
          exeQuoteCurrency
          marginCustomization
          pdfColumnCustomization
          pdfMiscCustomization
          summaryTableCustomization
          quoteHeaderLabel1
          quoteHeaderValue1
          quoteHeaderLabel2
          quoteHeaderValue2
          quoteHeaderLabel3
          quoteHeaderValue3
          quoteHeaderLabel4
          quoteHeaderValue4
          quoteHeaderLabel5
          quoteHeaderValue5
          quoteHeaderLabel6
          quoteHeaderValue6
          quoteHeaderLabel7
          quoteHeaderValue7
          quoteHeaderLabel8
          quoteHeaderValue8
          quoteHeaderLabel9
          quoteHeaderValue9
          quoteHeaderLabel10
          quoteHeaderValue10
          quoteHeaderLabel11
          quoteHeaderValue11
          productionNoteLabels
          budgetSections
          showCo2InSummary
          showCo2InPdf
          numberOfPrepDaysCo2
          numberOfShootDaysCo2
          numberOfPeopleOnSetCo2
          enableTravelCo2
          travelTypeCo2
          percentageOfCrewTravelCo2
          travelTypeLocation2Co2
          percentageOfCrewTravelLocation2Co2
          overtimeHours1Rate
          overtimeHours2Rate
          overtimeHours3Rate
          overtimeHours4Rate
          assignedTenantId
          assignedTenantName
          isExpired
          createdOn
          updatedOn
          _deleted
          _version
          _lastChangedAt
        }
        invoices {
          nextToken
        }
        createdOn
        updatedOn
        poDate
        poName
        poAmount
        poCurrency
        poNotes
        poDocuments {
          bucket
          region
          key
          identityId
        }
        poVersion
        prevStatus
        assignedTenantId
        assignedTenantName
        showBidLetter
        companyLogo
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnUpdateQuoteSubscriptionVariables,
		APITypes.OnUpdateQuoteSubscription
	>
export const onDeleteQuote =
	/* GraphQL */ `subscription OnDeleteQuote($filter: ModelSubscriptionQuoteFilterInput) {
  onDeleteQuote(filter: $filter) {
    id
    name
    tenantId
    quoteType
    quoteVersion
    aiGenerationRunId
    aiGenerationStatus
    aiGenerationError
    aiGenerationStartedAt
    aiGenerationCompletedAt
    aiGeneratedByUserId
    blankQuoteType
    parentTeamId
    parentSubTeamId
    visibility
    quoteLanguage
    childFreelancers
    offlineIds
    activeFlag
    type
    mergedQuotes
    parentProjectId
    billLocation
    marginLabel
    overheadLabel
    marginAndOverheadLabel
    marginPercentage
    overheadPercentage
    exchangeRate
    localExchangeRate
    localOtNumberOfHours
    exeOtNumberOfHours
    marginVAT_rate
    marginAcc_section
    allowInternational
    freelancers
    parentCompanyId
    companyLogo
    maximizeMinimize
    provisionalColumn
    selectContactById
    clientId
    contactId
    clientName
    projectName
    agency
    agencyRepresentative
    director
    executiveProducer
    lineProducer
    numberOfShootingDays
    notes
    introduction
    shooting
    prep
    shootingCountry
    prelight
    casting
    crew
    buyouts
    locations
    studio
    artDepartment
    wardrobe
    equipment
    travel
    accommodation
    editing
    imagePostproduction
    soundPostproduction
    deliverables
    insurance
    quoteGuidelines
    excluded
    paymentTerms
    miscellaneous
    conclusion
    installment1Percentage
    installment1Date
    installment2Percentage
    installment2Date
    balancePercentage
    balanceDate
    isStarred
    isChecked
    isFinalized
    recapInfoComments
    contact
    quoteTotal {
      budgetSubTotal
      budgetGrandTotal
      budgetMargin
      budgetMarginPercentage
      budgetSeperateMargin
      budgetSeperateMarginPercentage
      budgetSeperateOverhead
      budgetSeperateOverheadPercentage
      provisionalSubTotal
      provisionalGrandTotal
      provisionalMargin
      provisionalMarginPercentage
      actualSubTotal
      actualGrandTotal
      actualMargin
      actualMarginPercentage
      purchaseSubTotal
      purchaseGrandTotal
      purchaseMargin
      purchaseMarginPercentage
      grandBudgetWithMarginTotal
      noMarginTotalPercentage
      subTotalBudgetWithMargin
      subTotalBudgetWithoutMargin
      subTotalBudgetWithMarginPercentage
    }
    quoteTotalDiscount {
      totalAfterDiscount
      totalDiscount
      budgetTotalDiscountOnMargin
      budgetTotalDiscountOnMarginPercentage
      budgetTotalDiscountPercentage
      provisionalTotalDiscountOnMargin
      provisionalTotalDiscountOnMarginPercentage
      provisionalTotalDiscountPercentage
      actualTotalDiscountOnMargin
      actualTotalDiscountOnMarginPercentage
      actualTotalDiscountPercentage
      purchaseTotalDiscountOnMargin
      purchaseTotalDiscountOnMarginPercentage
      purchaseTotalDiscountPercentage
    }
    discount {
      totalDiscount
      totalAfterDiscount
      totalDiscountOnMargin
      totalDiscountOnMarginPercentage
      totalDiscountPercentage
    }
    quoteNumber
    quoteAccountingCategory
    deliveryDate
    quoteTertiaryCategory
    exeLocation
    advertiserJobID
    brand
    jobName
    agencyJobID
    product
    advertiser
    productionJobID
    advertiserAddress
    productionCompany
    productionContact
    vfxCo
    vfxProducer
    editorialCo
    editorialProducer
    musicCo
    musicProducer
    agencyProducer
    agencyCreativeTeam
    prepDays
    buildAndStrikeDays
    preLight
    stageDays
    locationDays
    description
    service
    scope
    vhr
    billingAddress
    dateOfShoot
    photographer
    jobNumber
    photoLocation
    quoteProdValue1
    quoteProdValue2
    quoteProdValue3
    quoteProdValue4
    quoteProdValue5
    quoteProdValue6
    quoteProdValue7
    quoteProdValue8
    quoteProdValue9
    quoteProdValue10
    quoteProdValue11
    quoteProdValue12
    quoteProdValue13
    quoteProdValue14
    quoteProdValue15
    quoteProdValue16
    quoteProdValue17
    quoteProdValue18
    quoteProdValue19
    quoteProdValue20
    quoteProdValue21
    quoteProdValue22
    quoteProdValue23
    quoteProdValue24
    quoteProdValue25
    termsType
    termsSelection
    quoteCurrency
    exeQuoteCurrency
    marginCustomization
    pdfColumnCustomization
    pdfMiscCustomization
    summaryTableCustomization
    quoteHeaderLabel1
    quoteHeaderValue1
    quoteHeaderLabel2
    quoteHeaderValue2
    quoteHeaderLabel3
    quoteHeaderValue3
    quoteHeaderLabel4
    quoteHeaderValue4
    quoteHeaderLabel5
    quoteHeaderValue5
    quoteHeaderLabel6
    quoteHeaderValue6
    quoteHeaderLabel7
    quoteHeaderValue7
    quoteHeaderLabel8
    quoteHeaderValue8
    quoteHeaderLabel9
    quoteHeaderValue9
    quoteHeaderLabel10
    quoteHeaderValue10
    quoteHeaderLabel11
    quoteHeaderValue11
    productionNoteLabels
    budgetSections
    showCo2InSummary
    showCo2InPdf
    numberOfPrepDaysCo2
    numberOfShootDaysCo2
    numberOfPeopleOnSetCo2
    enableTravelCo2
    travelTypeCo2
    percentageOfCrewTravelCo2
    travelTypeLocation2Co2
    percentageOfCrewTravelLocation2Co2
    overtimeHours1Rate
    overtimeHours2Rate
    overtimeHours3Rate
    overtimeHours4Rate
    assignedTenantId
    assignedTenantName
    isExpired
    filledCostlineDetails {
      totalBudget
      totalCrewBudget
      totalPostProdBudget
      crewPrepNumberOfDays
      crewShootNumberOfDays
    }
    proposals {
      items {
        id
        tenantId
        activeFlag
        quoteId
        quoteType
        clientId
        contactId
        status
        noofInvoices
        quoteName
        quoteNumber
        projectName
        projectNumber
        clientTaxType
        clientName
        contactName
        clientEmail
        clientAddress
        clientCountry
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        paymentTerms
        total
        clientNote
        isDetailed
        isClientTaxRate
        bankProfileNumber
        proposalsBankProfileName
        proposalsBank
        proposalsIban
        proposalsBic
        proposalsAccountName
        drafts {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
          salesAccNumberType
        }
        quote {
          id
          name
          tenantId
          quoteType
          quoteVersion
          aiGenerationRunId
          aiGenerationStatus
          aiGenerationError
          aiGenerationStartedAt
          aiGenerationCompletedAt
          aiGeneratedByUserId
          blankQuoteType
          parentTeamId
          parentSubTeamId
          visibility
          quoteLanguage
          childFreelancers
          offlineIds
          activeFlag
          type
          mergedQuotes
          parentProjectId
          billLocation
          marginLabel
          overheadLabel
          marginAndOverheadLabel
          marginPercentage
          overheadPercentage
          exchangeRate
          localExchangeRate
          localOtNumberOfHours
          exeOtNumberOfHours
          marginVAT_rate
          marginAcc_section
          allowInternational
          freelancers
          parentCompanyId
          companyLogo
          maximizeMinimize
          provisionalColumn
          selectContactById
          clientId
          contactId
          clientName
          projectName
          agency
          agencyRepresentative
          director
          executiveProducer
          lineProducer
          numberOfShootingDays
          notes
          introduction
          shooting
          prep
          shootingCountry
          prelight
          casting
          crew
          buyouts
          locations
          studio
          artDepartment
          wardrobe
          equipment
          travel
          accommodation
          editing
          imagePostproduction
          soundPostproduction
          deliverables
          insurance
          quoteGuidelines
          excluded
          paymentTerms
          miscellaneous
          conclusion
          installment1Percentage
          installment1Date
          installment2Percentage
          installment2Date
          balancePercentage
          balanceDate
          isStarred
          isChecked
          isFinalized
          recapInfoComments
          contact
          quoteNumber
          quoteAccountingCategory
          deliveryDate
          quoteTertiaryCategory
          exeLocation
          advertiserJobID
          brand
          jobName
          agencyJobID
          product
          advertiser
          productionJobID
          advertiserAddress
          productionCompany
          productionContact
          vfxCo
          vfxProducer
          editorialCo
          editorialProducer
          musicCo
          musicProducer
          agencyProducer
          agencyCreativeTeam
          prepDays
          buildAndStrikeDays
          preLight
          stageDays
          locationDays
          description
          service
          scope
          vhr
          billingAddress
          dateOfShoot
          photographer
          jobNumber
          photoLocation
          quoteProdValue1
          quoteProdValue2
          quoteProdValue3
          quoteProdValue4
          quoteProdValue5
          quoteProdValue6
          quoteProdValue7
          quoteProdValue8
          quoteProdValue9
          quoteProdValue10
          quoteProdValue11
          quoteProdValue12
          quoteProdValue13
          quoteProdValue14
          quoteProdValue15
          quoteProdValue16
          quoteProdValue17
          quoteProdValue18
          quoteProdValue19
          quoteProdValue20
          quoteProdValue21
          quoteProdValue22
          quoteProdValue23
          quoteProdValue24
          quoteProdValue25
          termsType
          termsSelection
          quoteCurrency
          exeQuoteCurrency
          marginCustomization
          pdfColumnCustomization
          pdfMiscCustomization
          summaryTableCustomization
          quoteHeaderLabel1
          quoteHeaderValue1
          quoteHeaderLabel2
          quoteHeaderValue2
          quoteHeaderLabel3
          quoteHeaderValue3
          quoteHeaderLabel4
          quoteHeaderValue4
          quoteHeaderLabel5
          quoteHeaderValue5
          quoteHeaderLabel6
          quoteHeaderValue6
          quoteHeaderLabel7
          quoteHeaderValue7
          quoteHeaderLabel8
          quoteHeaderValue8
          quoteHeaderLabel9
          quoteHeaderValue9
          quoteHeaderLabel10
          quoteHeaderValue10
          quoteHeaderLabel11
          quoteHeaderValue11
          productionNoteLabels
          budgetSections
          showCo2InSummary
          showCo2InPdf
          numberOfPrepDaysCo2
          numberOfShootDaysCo2
          numberOfPeopleOnSetCo2
          enableTravelCo2
          travelTypeCo2
          percentageOfCrewTravelCo2
          travelTypeLocation2Co2
          percentageOfCrewTravelLocation2Co2
          overtimeHours1Rate
          overtimeHours2Rate
          overtimeHours3Rate
          overtimeHours4Rate
          assignedTenantId
          assignedTenantName
          isExpired
          createdOn
          updatedOn
          _deleted
          _version
          _lastChangedAt
        }
        invoices {
          nextToken
        }
        createdOn
        updatedOn
        poDate
        poName
        poAmount
        poCurrency
        poNotes
        poDocuments {
          bucket
          region
          key
          identityId
        }
        poVersion
        prevStatus
        assignedTenantId
        assignedTenantName
        showBidLetter
        companyLogo
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnDeleteQuoteSubscriptionVariables,
		APITypes.OnDeleteQuoteSubscription
	>
export const onCreateQuoteInfo =
	/* GraphQL */ `subscription OnCreateQuoteInfo($filter: ModelSubscriptionQuoteInfoFilterInput) {
  onCreateQuoteInfo(filter: $filter) {
    id
    quoteId
    tenantId
    originalQuoteId
    freelancers
    childFreelancers
    offlineIds
    activeFlag
    agentCommission
    agentCommissionPercentage
    allowMarginAndOverheadPercentageGlobalUpdate
    language
    costlineUuid
    category
    categoryId
    categoryPrefix
    category_fr
    categoryUuid
    categoryLabelValue
    costLineLabel
    costLineEditLabel
    costLineType
    costLineCurrency
    editable
    exchangeEnabled
    exchangeRate
    tableRowIndex
    fractionalSortKey
    isInternational
    isVisible
    item
    item_fr
    margin
    marginPercentage
    number
    shootNumber
    overhead
    overheadPercentage
    discountPercentage
    overtimeDetails {
      multiplier
      overtimeHours
    }
    overtimeHours1
    overtimeHours2
    overtimeHours3
    overtimeHours4
    overtimeHours
    otNumberOfHours
    overtimeHoursCost
    payrollTaxEnabled
    payrollTaxType
    quantity
    rate
    rateInEuros
    rowColor
    costlineHeader
    subCategory
    subCategoryId
    subCategoryPrefix
    subCategorySuffix
    subCategory_fr
    subCategoryUuid
    subCategoryLabelValue
    thirdLevelSection
    thirdLevelSectionId
    thirdLevelSectionPrefix
    thirdLevelSection_fr
    thirdLevelSectionUuid
    thirdLevelSectionLabelValue
    total
    totalHeading
    totalMargin
    unit
    smg
    VAT_rate
    Acc_section
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnCreateQuoteInfoSubscriptionVariables,
		APITypes.OnCreateQuoteInfoSubscription
	>
export const onUpdateQuoteInfo =
	/* GraphQL */ `subscription OnUpdateQuoteInfo($filter: ModelSubscriptionQuoteInfoFilterInput) {
  onUpdateQuoteInfo(filter: $filter) {
    id
    quoteId
    tenantId
    originalQuoteId
    freelancers
    childFreelancers
    offlineIds
    activeFlag
    agentCommission
    agentCommissionPercentage
    allowMarginAndOverheadPercentageGlobalUpdate
    language
    costlineUuid
    category
    categoryId
    categoryPrefix
    category_fr
    categoryUuid
    categoryLabelValue
    costLineLabel
    costLineEditLabel
    costLineType
    costLineCurrency
    editable
    exchangeEnabled
    exchangeRate
    tableRowIndex
    fractionalSortKey
    isInternational
    isVisible
    item
    item_fr
    margin
    marginPercentage
    number
    shootNumber
    overhead
    overheadPercentage
    discountPercentage
    overtimeDetails {
      multiplier
      overtimeHours
    }
    overtimeHours1
    overtimeHours2
    overtimeHours3
    overtimeHours4
    overtimeHours
    otNumberOfHours
    overtimeHoursCost
    payrollTaxEnabled
    payrollTaxType
    quantity
    rate
    rateInEuros
    rowColor
    costlineHeader
    subCategory
    subCategoryId
    subCategoryPrefix
    subCategorySuffix
    subCategory_fr
    subCategoryUuid
    subCategoryLabelValue
    thirdLevelSection
    thirdLevelSectionId
    thirdLevelSectionPrefix
    thirdLevelSection_fr
    thirdLevelSectionUuid
    thirdLevelSectionLabelValue
    total
    totalHeading
    totalMargin
    unit
    smg
    VAT_rate
    Acc_section
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnUpdateQuoteInfoSubscriptionVariables,
		APITypes.OnUpdateQuoteInfoSubscription
	>
export const onDeleteQuoteInfo =
	/* GraphQL */ `subscription OnDeleteQuoteInfo($filter: ModelSubscriptionQuoteInfoFilterInput) {
  onDeleteQuoteInfo(filter: $filter) {
    id
    quoteId
    tenantId
    originalQuoteId
    freelancers
    childFreelancers
    offlineIds
    activeFlag
    agentCommission
    agentCommissionPercentage
    allowMarginAndOverheadPercentageGlobalUpdate
    language
    costlineUuid
    category
    categoryId
    categoryPrefix
    category_fr
    categoryUuid
    categoryLabelValue
    costLineLabel
    costLineEditLabel
    costLineType
    costLineCurrency
    editable
    exchangeEnabled
    exchangeRate
    tableRowIndex
    fractionalSortKey
    isInternational
    isVisible
    item
    item_fr
    margin
    marginPercentage
    number
    shootNumber
    overhead
    overheadPercentage
    discountPercentage
    overtimeDetails {
      multiplier
      overtimeHours
    }
    overtimeHours1
    overtimeHours2
    overtimeHours3
    overtimeHours4
    overtimeHours
    otNumberOfHours
    overtimeHoursCost
    payrollTaxEnabled
    payrollTaxType
    quantity
    rate
    rateInEuros
    rowColor
    costlineHeader
    subCategory
    subCategoryId
    subCategoryPrefix
    subCategorySuffix
    subCategory_fr
    subCategoryUuid
    subCategoryLabelValue
    thirdLevelSection
    thirdLevelSectionId
    thirdLevelSectionPrefix
    thirdLevelSection_fr
    thirdLevelSectionUuid
    thirdLevelSectionLabelValue
    total
    totalHeading
    totalMargin
    unit
    smg
    VAT_rate
    Acc_section
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnDeleteQuoteInfoSubscriptionVariables,
		APITypes.OnDeleteQuoteInfoSubscription
	>
export const onCreateRecapInfo =
	/* GraphQL */ `subscription OnCreateRecapInfo($filter: ModelSubscriptionRecapInfoFilterInput) {
  onCreateRecapInfo(filter: $filter) {
    id
    quoteId
    tenantId
    originalQuoteId
    freelancers
    childFreelancers
    offlineIds
    activeFlag
    uuid
    costlineUuid
    categoryId
    categoryUuid
    category
    category_fr
    categoryPrefix
    categoryLabelValue
    subCategoryId
    subCategoryUuid
    subCategory
    subCategory_fr
    subCategoryPrefix
    subCategorySuffix
    subCategoryLabelValue
    thirdLevelSection
    thirdLevelSectionId
    thirdLevelSectionPrefix
    thirdLevelSection_fr
    thirdLevelSectionUuid
    thirdLevelSectionLabelValue
    tableRowIndex
    fractionalSortKey
    item
    item_fr
    isInternational
    editable
    costLineType
    costLineLabel
    costLineEditLabel
    language
    number
    shootNumber
    rate
    exchangeEnabled
    exchangeRate
    rateInEuros
    quantity
    total
    totalMargin
    payrollTaxEnabled
    payrollTaxType
    overtimeHours1
    overtimeHours2
    overtimeHours3
    overtimeHours4
    otNumberOfHours
    overtimeHoursCost
    isCustomCostLine
    referenceCostLineUuid
    provisionalQuantity
    provisionalNumber
    provisionalShootNumber
    provisionalRate
    provisionalOtTotal
    provisionalTotal
    provisionalPayrollTaxEnabled
    provisionalPayrollTaxType
    actualTotal
    actualPayrollTaxEnabled
    actualPayrollTaxType
    purchaseTotal
    supplierStatus
    supplierId
    paymentStatus
    purchaseId
    comments
    invoiceId
    invoiceAvailable
    invoiceDocuments {
      bucket
      region
      key
      identityId
    }
    poAvailable
    purchaseOrderId
    rowColor
    costlineHeader
    startDate
    endDate
    days
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnCreateRecapInfoSubscriptionVariables,
		APITypes.OnCreateRecapInfoSubscription
	>
export const onUpdateRecapInfo =
	/* GraphQL */ `subscription OnUpdateRecapInfo($filter: ModelSubscriptionRecapInfoFilterInput) {
  onUpdateRecapInfo(filter: $filter) {
    id
    quoteId
    tenantId
    originalQuoteId
    freelancers
    childFreelancers
    offlineIds
    activeFlag
    uuid
    costlineUuid
    categoryId
    categoryUuid
    category
    category_fr
    categoryPrefix
    categoryLabelValue
    subCategoryId
    subCategoryUuid
    subCategory
    subCategory_fr
    subCategoryPrefix
    subCategorySuffix
    subCategoryLabelValue
    thirdLevelSection
    thirdLevelSectionId
    thirdLevelSectionPrefix
    thirdLevelSection_fr
    thirdLevelSectionUuid
    thirdLevelSectionLabelValue
    tableRowIndex
    fractionalSortKey
    item
    item_fr
    isInternational
    editable
    costLineType
    costLineLabel
    costLineEditLabel
    language
    number
    shootNumber
    rate
    exchangeEnabled
    exchangeRate
    rateInEuros
    quantity
    total
    totalMargin
    payrollTaxEnabled
    payrollTaxType
    overtimeHours1
    overtimeHours2
    overtimeHours3
    overtimeHours4
    otNumberOfHours
    overtimeHoursCost
    isCustomCostLine
    referenceCostLineUuid
    provisionalQuantity
    provisionalNumber
    provisionalShootNumber
    provisionalRate
    provisionalOtTotal
    provisionalTotal
    provisionalPayrollTaxEnabled
    provisionalPayrollTaxType
    actualTotal
    actualPayrollTaxEnabled
    actualPayrollTaxType
    purchaseTotal
    supplierStatus
    supplierId
    paymentStatus
    purchaseId
    comments
    invoiceId
    invoiceAvailable
    invoiceDocuments {
      bucket
      region
      key
      identityId
    }
    poAvailable
    purchaseOrderId
    rowColor
    costlineHeader
    startDate
    endDate
    days
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnUpdateRecapInfoSubscriptionVariables,
		APITypes.OnUpdateRecapInfoSubscription
	>
export const onDeleteRecapInfo =
	/* GraphQL */ `subscription OnDeleteRecapInfo($filter: ModelSubscriptionRecapInfoFilterInput) {
  onDeleteRecapInfo(filter: $filter) {
    id
    quoteId
    tenantId
    originalQuoteId
    freelancers
    childFreelancers
    offlineIds
    activeFlag
    uuid
    costlineUuid
    categoryId
    categoryUuid
    category
    category_fr
    categoryPrefix
    categoryLabelValue
    subCategoryId
    subCategoryUuid
    subCategory
    subCategory_fr
    subCategoryPrefix
    subCategorySuffix
    subCategoryLabelValue
    thirdLevelSection
    thirdLevelSectionId
    thirdLevelSectionPrefix
    thirdLevelSection_fr
    thirdLevelSectionUuid
    thirdLevelSectionLabelValue
    tableRowIndex
    fractionalSortKey
    item
    item_fr
    isInternational
    editable
    costLineType
    costLineLabel
    costLineEditLabel
    language
    number
    shootNumber
    rate
    exchangeEnabled
    exchangeRate
    rateInEuros
    quantity
    total
    totalMargin
    payrollTaxEnabled
    payrollTaxType
    overtimeHours1
    overtimeHours2
    overtimeHours3
    overtimeHours4
    otNumberOfHours
    overtimeHoursCost
    isCustomCostLine
    referenceCostLineUuid
    provisionalQuantity
    provisionalNumber
    provisionalShootNumber
    provisionalRate
    provisionalOtTotal
    provisionalTotal
    provisionalPayrollTaxEnabled
    provisionalPayrollTaxType
    actualTotal
    actualPayrollTaxEnabled
    actualPayrollTaxType
    purchaseTotal
    supplierStatus
    supplierId
    paymentStatus
    purchaseId
    comments
    invoiceId
    invoiceAvailable
    invoiceDocuments {
      bucket
      region
      key
      identityId
    }
    poAvailable
    purchaseOrderId
    rowColor
    costlineHeader
    startDate
    endDate
    days
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnDeleteRecapInfoSubscriptionVariables,
		APITypes.OnDeleteRecapInfoSubscription
	>
export const onCreateSectionRename =
	/* GraphQL */ `subscription OnCreateSectionRename(
  $filter: ModelSubscriptionSectionRenameFilterInput
) {
  onCreateSectionRename(filter: $filter) {
    id
    quoteId
    tenantId
    sectionId
    sectionType
    sectionName
    sectionName_fr
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnCreateSectionRenameSubscriptionVariables,
		APITypes.OnCreateSectionRenameSubscription
	>
export const onUpdateSectionRename =
	/* GraphQL */ `subscription OnUpdateSectionRename(
  $filter: ModelSubscriptionSectionRenameFilterInput
) {
  onUpdateSectionRename(filter: $filter) {
    id
    quoteId
    tenantId
    sectionId
    sectionType
    sectionName
    sectionName_fr
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnUpdateSectionRenameSubscriptionVariables,
		APITypes.OnUpdateSectionRenameSubscription
	>
export const onDeleteSectionRename =
	/* GraphQL */ `subscription OnDeleteSectionRename(
  $filter: ModelSubscriptionSectionRenameFilterInput
) {
  onDeleteSectionRename(filter: $filter) {
    id
    quoteId
    tenantId
    sectionId
    sectionType
    sectionName
    sectionName_fr
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnDeleteSectionRenameSubscriptionVariables,
		APITypes.OnDeleteSectionRenameSubscription
	>
export const onCreateSubscriptionDetails =
	/* GraphQL */ `subscription OnCreateSubscriptionDetails(
  $filter: ModelSubscriptionSubscriptionDetailsFilterInput
) {
  onCreateSubscriptionDetails(filter: $filter) {
    id
    tenantId
    stripeId
    subscriptionEndDate
    subscriptionStatus
    isEnterpriseUser
    subscriptionSubId
    subscriptionPriceId
    subscriptionProductId
    stripePaymentMethodId
    actualPaidTeamCount
    totalTeamCount
    activeFlag
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnCreateSubscriptionDetailsSubscriptionVariables,
		APITypes.OnCreateSubscriptionDetailsSubscription
	>
export const onUpdateSubscriptionDetails =
	/* GraphQL */ `subscription OnUpdateSubscriptionDetails(
  $filter: ModelSubscriptionSubscriptionDetailsFilterInput
) {
  onUpdateSubscriptionDetails(filter: $filter) {
    id
    tenantId
    stripeId
    subscriptionEndDate
    subscriptionStatus
    isEnterpriseUser
    subscriptionSubId
    subscriptionPriceId
    subscriptionProductId
    stripePaymentMethodId
    actualPaidTeamCount
    totalTeamCount
    activeFlag
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnUpdateSubscriptionDetailsSubscriptionVariables,
		APITypes.OnUpdateSubscriptionDetailsSubscription
	>
export const onDeleteSubscriptionDetails =
	/* GraphQL */ `subscription OnDeleteSubscriptionDetails(
  $filter: ModelSubscriptionSubscriptionDetailsFilterInput
) {
  onDeleteSubscriptionDetails(filter: $filter) {
    id
    tenantId
    stripeId
    subscriptionEndDate
    subscriptionStatus
    isEnterpriseUser
    subscriptionSubId
    subscriptionPriceId
    subscriptionProductId
    stripePaymentMethodId
    actualPaidTeamCount
    totalTeamCount
    activeFlag
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedSubscription<
		APITypes.OnDeleteSubscriptionDetailsSubscriptionVariables,
		APITypes.OnDeleteSubscriptionDetailsSubscription
	>
export const onCreateSuppliers =
	/* GraphQL */ `subscription OnCreateSuppliers($filter: ModelSubscriptionSuppliersFilterInput) {
  onCreateSuppliers(filter: $filter) {
    id
    tenantId
    activeFlag
    name
    idnumber
    vatNumber
    website
    phone
    firstName
    lastName
    contactEmail
    companyEmail
    contactPhone
    line01
    line02
    city
    state
    postalCode
    country
    currency
    paymentTerms
    taxType
    taxRate
    thirdPartyAccounts
    note
    bank
    iban
    bic
    accountName
    commercialName
    supplierCreditorAccount
    supplierSubAccount
    supplierType
    individualType
    isArchived
    internalADR
    quoteSectionDetails {
      quoteType
      categoryUuid
      subCategoryUuid
      categoryName
      subCategoryName
      categoryName_fr
      subCategoryName_fr
    }
    purchase {
      items {
        id
        tenantId
        activeFlag
        quoteId
        supplierId
        recapCostlineId
        quoteName
        projectName
        supplierName
        recapCostlineItem
        recapCostlineItem_fr
        currency
        provisionalTotal
        invoiceTotal
        taxAmount
        purchaseInvoiceDueDate
        purchaseArchivedDate
        purchasePaidDate
        supplierCreditorAccount
        purchaseOrderId
        poAvailable
        invoiceAvailable
        paymentStatus
        purchaseType
        supplierType
        invoiceKey
        tags
        invoiceDocuments {
          bucket
          region
          key
          identityId
        }
        quoteNumber
        projectNumber
        invoiceNumber
        purchaseToPayDate
        purchaseNumber
        purchaseOrderNumber
        projectId
        supplierTerms
        quantity
        number
        rate
        taxRate
        deliveryDate
        deliveryAddress
        poComments
        poGenerated
        createdOn
        updatedOn
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedSubscription<
		APITypes.OnCreateSuppliersSubscriptionVariables,
		APITypes.OnCreateSuppliersSubscription
	>
export const onUpdateSuppliers =
	/* GraphQL */ `subscription OnUpdateSuppliers($filter: ModelSubscriptionSuppliersFilterInput) {
  onUpdateSuppliers(filter: $filter) {
    id
    tenantId
    activeFlag
    name
    idnumber
    vatNumber
    website
    phone
    firstName
    lastName
    contactEmail
    companyEmail
    contactPhone
    line01
    line02
    city
    state
    postalCode
    country
    currency
    paymentTerms
    taxType
    taxRate
    thirdPartyAccounts
    note
    bank
    iban
    bic
    accountName
    commercialName
    supplierCreditorAccount
    supplierSubAccount
    supplierType
    individualType
    isArchived
    internalADR
    quoteSectionDetails {
      quoteType
      categoryUuid
      subCategoryUuid
      categoryName
      subCategoryName
      categoryName_fr
      subCategoryName_fr
    }
    purchase {
      items {
        id
        tenantId
        activeFlag
        quoteId
        supplierId
        recapCostlineId
        quoteName
        projectName
        supplierName
        recapCostlineItem
        recapCostlineItem_fr
        currency
        provisionalTotal
        invoiceTotal
        taxAmount
        purchaseInvoiceDueDate
        purchaseArchivedDate
        purchasePaidDate
        supplierCreditorAccount
        purchaseOrderId
        poAvailable
        invoiceAvailable
        paymentStatus
        purchaseType
        supplierType
        invoiceKey
        tags
        invoiceDocuments {
          bucket
          region
          key
          identityId
        }
        quoteNumber
        projectNumber
        invoiceNumber
        purchaseToPayDate
        purchaseNumber
        purchaseOrderNumber
        projectId
        supplierTerms
        quantity
        number
        rate
        taxRate
        deliveryDate
        deliveryAddress
        poComments
        poGenerated
        createdOn
        updatedOn
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedSubscription<
		APITypes.OnUpdateSuppliersSubscriptionVariables,
		APITypes.OnUpdateSuppliersSubscription
	>
export const onDeleteSuppliers =
	/* GraphQL */ `subscription OnDeleteSuppliers($filter: ModelSubscriptionSuppliersFilterInput) {
  onDeleteSuppliers(filter: $filter) {
    id
    tenantId
    activeFlag
    name
    idnumber
    vatNumber
    website
    phone
    firstName
    lastName
    contactEmail
    companyEmail
    contactPhone
    line01
    line02
    city
    state
    postalCode
    country
    currency
    paymentTerms
    taxType
    taxRate
    thirdPartyAccounts
    note
    bank
    iban
    bic
    accountName
    commercialName
    supplierCreditorAccount
    supplierSubAccount
    supplierType
    individualType
    isArchived
    internalADR
    quoteSectionDetails {
      quoteType
      categoryUuid
      subCategoryUuid
      categoryName
      subCategoryName
      categoryName_fr
      subCategoryName_fr
    }
    purchase {
      items {
        id
        tenantId
        activeFlag
        quoteId
        supplierId
        recapCostlineId
        quoteName
        projectName
        supplierName
        recapCostlineItem
        recapCostlineItem_fr
        currency
        provisionalTotal
        invoiceTotal
        taxAmount
        purchaseInvoiceDueDate
        purchaseArchivedDate
        purchasePaidDate
        supplierCreditorAccount
        purchaseOrderId
        poAvailable
        invoiceAvailable
        paymentStatus
        purchaseType
        supplierType
        invoiceKey
        tags
        invoiceDocuments {
          bucket
          region
          key
          identityId
        }
        quoteNumber
        projectNumber
        invoiceNumber
        purchaseToPayDate
        purchaseNumber
        purchaseOrderNumber
        projectId
        supplierTerms
        quantity
        number
        rate
        taxRate
        deliveryDate
        deliveryAddress
        poComments
        poGenerated
        createdOn
        updatedOn
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedSubscription<
		APITypes.OnDeleteSuppliersSubscriptionVariables,
		APITypes.OnDeleteSuppliersSubscription
	>
export const onCreateUserInfo = /* GraphQL */ `subscription OnCreateUserInfo(
  $filter: ModelSubscriptionUserInfoFilterInput
  $owner: String
) {
  onCreateUserInfo(filter: $filter, owner: $owner) {
    id
    email
    activeFlag
    firstName
    lastName
    phone
    tenantId
    companyTenantId
    currentCompanyTenantId
    currentCompanyName
    cognitoGroup
    teamIds
    subTeamIds
    projectIds
    userLanguage
    hideTour
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
    owner
  }
}
` as GeneratedSubscription<
	APITypes.OnCreateUserInfoSubscriptionVariables,
	APITypes.OnCreateUserInfoSubscription
>
export const onUpdateUserInfo = /* GraphQL */ `subscription OnUpdateUserInfo(
  $filter: ModelSubscriptionUserInfoFilterInput
  $owner: String
) {
  onUpdateUserInfo(filter: $filter, owner: $owner) {
    id
    email
    activeFlag
    firstName
    lastName
    phone
    tenantId
    companyTenantId
    currentCompanyTenantId
    currentCompanyName
    cognitoGroup
    teamIds
    subTeamIds
    projectIds
    userLanguage
    hideTour
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
    owner
  }
}
` as GeneratedSubscription<
	APITypes.OnUpdateUserInfoSubscriptionVariables,
	APITypes.OnUpdateUserInfoSubscription
>
export const onDeleteUserInfo = /* GraphQL */ `subscription OnDeleteUserInfo(
  $filter: ModelSubscriptionUserInfoFilterInput
  $owner: String
) {
  onDeleteUserInfo(filter: $filter, owner: $owner) {
    id
    email
    activeFlag
    firstName
    lastName
    phone
    tenantId
    companyTenantId
    currentCompanyTenantId
    currentCompanyName
    cognitoGroup
    teamIds
    subTeamIds
    projectIds
    userLanguage
    hideTour
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
    owner
  }
}
` as GeneratedSubscription<
	APITypes.OnDeleteUserInfoSubscriptionVariables,
	APITypes.OnDeleteUserInfoSubscription
>
